// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/timeline/v4/timeline.proto (package wisetime.user.timeline.v4, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../../../google/api/annotations_pb";
import type { Duration } from "../../../../google/protobuf/duration_pb";
import { file_google_protobuf_duration } from "../../../../google/protobuf/duration_pb";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { SiteRef } from "../../../type/site_ref_pb";
import { file_wisetime_type_site_ref } from "../../../type/site_ref_pb";
import type { SelectedTimesheetFieldOption } from "../../type/selected_timesheet_field_option_pb";
import { file_wisetime_user_type_selected_timesheet_field_option } from "../../type/selected_timesheet_field_option_pb";
import type { TagRef } from "../../type/tag_ref_pb";
import { file_wisetime_user_type_tag_ref } from "../../type/tag_ref_pb";
import type { TagCategoryRef } from "../../type/tag_category_ref_pb";
import { file_wisetime_user_type_tag_category_ref } from "../../type/tag_category_ref_pb";
import type { TimelineStatusSchema } from "../../type/timeline_status_pb";
import { file_wisetime_user_type_timeline_status } from "../../type/timeline_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/timeline/v4/timeline.proto.
 */
export const file_wisetime_user_timeline_v4_timeline: GenFile = /*@__PURE__*/
  fileDesc("Cih3aXNldGltZS91c2VyL3RpbWVsaW5lL3Y0L3RpbWVsaW5lLnByb3RvEhl3aXNldGltZS51c2VyLnRpbWVsaW5lLnY0IjwKFExpc3RUaW1lbGluZXNSZXF1ZXN0EhIKCnN0YXJ0X2RhdGUYASABKAkSEAoIZW5kX2RhdGUYAiABKAkiTwoVTGlzdFRpbWVsaW5lc1Jlc3BvbnNlEjYKCXRpbWVsaW5lcxgBIAMoCzIjLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZWxpbmUimAIKCFRpbWVsaW5lEgwKBGRhdGUYBSABKAkSPgoSdGltZV9yb3dzX2luX3JhbmdlGAIgAygLMiIud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lUm93EkIKFHRpbWVfZ3JvdXBzX2luX3JhbmdlGAEgAygLMiQud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lR3JvdXASOgoHbWFya2VycxgGIAMoCzIpLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZWxpbmVNYXJrZXJKBAgDEARKBAgEEAVSF3RpbWVfcm93c19vdXRzaWRlX3JhbmdlUhl0aW1lX2dyb3Vwc19vdXRzaWRlX3JhbmdlIhoKGEdldFRpbWVsaW5lU3RhdHVzUmVxdWVzdCJXChdMaXN0RGF5U3VtbWFyaWVzUmVxdWVzdBISCgpzdGFydF9kYXRlGAEgASgJEhAKCGVuZF9kYXRlGAIgASgJSgQIAxAEUhB0aW1lX3pvbmVfb2Zmc2V0IlgKGExpc3REYXlTdW1tYXJpZXNSZXNwb25zZRI8Cg1kYXlfc3VtbWFyaWVzGAEgAygLMiUud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5EYXlTdW1tYXJ5IrcCCgpEYXlTdW1tYXJ5EgwKBGRhdGUYASABKAkSMQoOdG90YWxfdW5wb3N0ZWQYAyABKAsyGS5nb29nbGUucHJvdG9idWYuRHVyYXRpb24SEQoJaGFzX2Vycm9yGAUgASgIElMKE3RpbWVfcG9zdGVkX3RvX3NpdGUYBiADKAsyNi53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkRheVN1bW1hcnkuVGltZVBvc3RlZFRvU2l0ZRpUChBUaW1lUG9zdGVkVG9TaXRlEg8KB3NpdGVfaWQYASABKAkSLwoMdG90YWxfcG9zdGVkGAIgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uSgQIBBAFSgQIAhADUgx0b3RhbF9wb3N0ZWRSEHRpbWVfem9uZV9vZmZzZXQi+AEKGUxpc3RUaW1lUm93c0J5RGF0ZVJlcXVlc3QSGwoTc3RhcnRfYWN0aXZpdHlfZGF0ZRgBIAEoDRIZChFlbmRfYWN0aXZpdHlfZGF0ZRgCIAEoDRI/Cgtwb3N0X3N0YXR1cxgDIAEoDjIlLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuUG9zdFN0YXR1c0gAiAEBEkEKDHRyYXNoX3N0YXR1cxgEIAEoDjImLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVHJhc2hTdGF0dXNIAYgBAUIOCgxfcG9zdF9zdGF0dXNCDwoNX3RyYXNoX3N0YXR1cyJTChpMaXN0VGltZVJvd3NCeURhdGVSZXNwb25zZRI1Cgl0aW1lX3Jvd3MYASADKAsyIi53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVSb3ciHQobV2F0Y2hUaW1lbGluZVVwZGF0ZXNSZXF1ZXN0InAKDlRpbWVsaW5lVXBkYXRlEhoKEmRhdGVzX3dpdGhfdXBkYXRlcxgDIAMoCUoECAEQAkoECAIQA1IZdGltZV9yb3dzX3VwZGF0ZWRfaW5faG91clIbYWN0aXZpdHlfaG91cnNfd2l0aF91cGRhdGVzIqEBCg9Qb3N0VGltZVJlcXVlc3QSJAoEc2l0ZRgBIAEoCzIWLndpc2V0aW1lLnR5cGUuU2l0ZVJlZhI9Cgt0aW1lX2dyb3VwcxgDIAMoCzIoLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuUG9zdFRpbWVHcm91cEoECAQQBUoECAIQA1ISYXNzb2NpYXRlZF91c2VyX2lkUgl0aW1lX3Jvd3MiRQoVQ2FuY2VsUG9zdFRpbWVSZXF1ZXN0EhYKDnRpbWVfZ3JvdXBfaWRzGAEgAygJEhQKDHRpbWVfcm93X2lkcxgCIAMoCSIYChZDYW5jZWxQb3N0VGltZVJlc3BvbnNlIq8CCg1Qb3N0VGltZUdyb3VwEhUKDXRpbWVfZ3JvdXBfaWQYASABKAkSKAoEdGFncxgCIAMoCzIaLndpc2V0aW1lLnVzZXIudHlwZS5UYWdSZWYSWgogc2VsZWN0ZWRfdGltZXNoZWV0X2ZpZWxkX29wdGlvbnMYBiADKAsyMC53aXNldGltZS51c2VyLnR5cGUuU2VsZWN0ZWRUaW1lc2hlZXRGaWVsZE9wdGlvbhIxCg50b3RhbF9kdXJhdGlvbhgEIAEoCzIZLmdvb2dsZS5wcm90b2J1Zi5EdXJhdGlvbhI5ChZyb3VuZGVkX3RvdGFsX2R1cmF0aW9uGAUgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uSgQIAxAEUg1hY3Rpdml0eV90eXBlIvMEChBQb3N0VGltZVJlc3BvbnNlEhkKEXBvc3RlZF90b19zaXRlX2lkGAQgASgJElMKEHRpbWVfcm93X3Jlc3VsdHMYASADKAsyOS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlBvc3RUaW1lUmVzcG9uc2UuVGltZVJvd1Jlc3VsdBJXChJ0aW1lX2dyb3VwX3Jlc3VsdHMYAyADKAsyOy53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlBvc3RUaW1lUmVzcG9uc2UuVGltZUdyb3VwUmVzdWx0Ej8KHHJlbWFpbmluZ191c2VyX3VucG9zdGVkX3RpbWUYAiABKAsyGS5nb29nbGUucHJvdG9idWYuRHVyYXRpb24axAEKDVRpbWVSb3dSZXN1bHQSEwoLdGltZV9yb3dfaWQYASABKAkSNQoGc3RhdHVzGAMgASgOMiUud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5Qb3N0U3RhdHVzEhoKDWVycm9yX21lc3NhZ2UYBCABKAlIAIgBAUIQCg5fZXJyb3JfbWVzc2FnZUoECAUQBkoECAYQB0oECAIQA1IEdGFnc1IOYWN0aXZpdHlfdHlwZXNSEXBvc3RlZF90b19zaXRlX2lkGo0BCg9UaW1lR3JvdXBSZXN1bHQSFQoNdGltZV9ncm91cF9pZBgBIAEoCRI1CgZzdGF0dXMYAiABKA4yJS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlBvc3RTdGF0dXMSGgoNZXJyb3JfbWVzc2FnZRgDIAEoCUgAiAEBQhAKDl9lcnJvcl9tZXNzYWdlIhUKBklkTGlzdBILCgNpZHMYASADKAkixQEKEEF0dGFjaFRhZ1JlcXVlc3QSOQoMdGltZV9yb3dfaWRzGAEgASgLMiEud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5JZExpc3RIABI7Cg50aW1lX2dyb3VwX2lkcxgFIAEoCzIhLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuSWRMaXN0SAASDgoGdGFnX2lkGAQgASgJQgUKA2lkc0oECAIQA0oECAMQBFINdGltZV9ncm91cF9pZFIHc2l0ZV9pZCKFAQoRQXR0YWNoVGFnUmVzcG9uc2USOQoLdGltZV9ncm91cHMYASADKAsyJC53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVHcm91cBI1Cgl0aW1lX3Jvd3MYAiADKAsyIi53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVSb3cijwEKEERldGFjaFRhZ1JlcXVlc3QSOQoMdGltZV9yb3dfaWRzGAEgASgLMiEud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5JZExpc3RIABIXCg10aW1lX2dyb3VwX2lkGAIgASgJSAASDgoGdGFnX2lkGAQgASgJQggKBnRhcmdldEoECAMQBFIHc2l0ZV9pZCITChFEZXRhY2hUYWdSZXNwb25zZSKRAQoYRGV0YWNoVGFnQ2F0ZWdvcnlSZXF1ZXN0EjkKDHRpbWVfcm93X2lkcxgBIAEoCzIhLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuSWRMaXN0SAASFwoNdGltZV9ncm91cF9pZBgCIAEoCUgAEhcKD3RhZ19jYXRlZ29yeV9pZBgDIAEoCUIICgZ0YXJnZXQiGwoZRGV0YWNoVGFnQ2F0ZWdvcnlSZXNwb25zZSI3ChpBY2NlcHRUYWdTdWdnZXN0aW9uUmVxdWVzdBIZChF0YWdfc3VnZ2VzdGlvbl9pZBgBIAEoCSJcChtBY2NlcHRUYWdTdWdnZXN0aW9uUmVzcG9uc2USPQoRdXBkYXRlZF90aW1lX3Jvd3MYASADKAsyIi53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVSb3ciOAobRGVjbGluZVRhZ1N1Z2dlc3Rpb25SZXF1ZXN0EhkKEXRhZ19zdWdnZXN0aW9uX2lkGAEgASgJIl0KHERlY2xpbmVUYWdTdWdnZXN0aW9uUmVzcG9uc2USPQoRdXBkYXRlZF90aW1lX3Jvd3MYASADKAsyIi53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVSb3cilgEKFlNldEFjdGl2aXR5VHlwZVJlcXVlc3QSNwoMdGltZV9yb3dfaWRzGAEgASgLMiEud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5JZExpc3QSGAoQYWN0aXZpdHlfdHlwZV9pZBgDIAEoCUoECAIQA0oECAQQBVINdGltZV9ncm91cF9pZFIOdGltZV9ncm91cF9pZHMiGQoXU2V0QWN0aXZpdHlUeXBlUmVzcG9uc2UijgEKGFVuc2V0QWN0aXZpdHlUeXBlUmVxdWVzdBI5Cgx0aW1lX3Jvd19pZHMYASABKAsyIS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LklkTGlzdEgAEhgKEGFjdGl2aXR5X3R5cGVfaWQYAyABKAlCCAoGdGFyZ2V0SgQIAhADUg10aW1lX2dyb3VwX2lkIhsKGVVuc2V0QWN0aXZpdHlUeXBlUmVzcG9uc2UiigEKIVNlbGVjdFRpbWVzaGVldEZpZWxkT3B0aW9uUmVxdWVzdBIVCg10aW1lX2dyb3VwX2lkGAEgASgJEg8KB3NpdGVfaWQYBCABKAkSGgoSdGltZXNoZWV0X2ZpZWxkX2lkGAIgASgJEiEKGXRpbWVzaGVldF9maWVsZF9vcHRpb25faWQYAyABKAkiYAoaQ2xlYXJUaW1lc2hlZXRGaWVsZFJlcXVlc3QSFQoNdGltZV9ncm91cF9pZBgBIAEoCRIPCgdzaXRlX2lkGAMgASgJEhoKEnRpbWVzaGVldF9maWVsZF9pZBgCIAEoCSKMAQokU2VsZWN0Um93VGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0EhQKDHRpbWVfcm93X2lkcxgBIAMoCRIPCgdzaXRlX2lkGAQgASgJEhoKEnRpbWVzaGVldF9maWVsZF9pZBgCIAEoCRIhChl0aW1lc2hlZXRfZmllbGRfb3B0aW9uX2lkGAMgASgJIl4KJVNlbGVjdFJvd1RpbWVzaGVldEZpZWxkT3B0aW9uUmVzcG9uc2USNQoJdGltZV9yb3dzGAEgAygLMiIud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lUm93ImIKHUNsZWFyUm93VGltZXNoZWV0RmllbGRSZXF1ZXN0EhQKDHRpbWVfcm93X2lkcxgBIAMoCRIPCgdzaXRlX2lkGAMgASgJEhoKEnRpbWVzaGVldF9maWVsZF9pZBgCIAEoCSJXCh5DbGVhclJvd1RpbWVzaGVldEZpZWxkUmVzcG9uc2USNQoJdGltZV9yb3dzGAEgAygLMiIud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lUm93IiwKFFRyYXNoVGltZVJvd3NSZXF1ZXN0EhQKDHRpbWVfcm93X2lkcxgBIAMoCSIXChVUcmFzaFRpbWVSb3dzUmVzcG9uc2UiLgoWVW5UcmFzaFRpbWVSb3dzUmVxdWVzdBIUCgx0aW1lX3Jvd19pZHMYASADKAkiGQoXVW5UcmFzaFRpbWVSb3dzUmVzcG9uc2UiOAogSW1tZWRpYXRlbHlEZWxldGVUaW1lUm93c1JlcXVlc3QSFAoMdGltZV9yb3dfaWRzGAEgAygJIiMKIUltbWVkaWF0ZWx5RGVsZXRlVGltZVJvd3NSZXNwb25zZSITChFFbXB0eVRyYXNoUmVxdWVzdCI1ChJFbXB0eVRyYXNoUmVzcG9uc2USHwoXZGVsZXRlZF90aW1lX3Jvd3NfY291bnQYASABKA0ikwEKFkNyZWF0ZVRpbWVHcm91cFJlcXVlc3QSFAoMdGltZV9yb3dfaWRzGAEgAygJEkoKDm5hcnJhdGl2ZV90eXBlGAQgASgOMjIud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lR3JvdXAuTmFycmF0aXZlVHlwZUoECAMQBEoECAIQA1IFY29sb3JSBG5hbWUi9AIKG0NyZWF0ZUVtcHR5VGltZUdyb3VwUmVxdWVzdBIVCg1hY3Rpdml0eV9kYXRlGAEgASgJEhEKBG5hbWUYAiABKAlIAIgBARJKCg5uYXJyYXRpdmVfdHlwZRgEIAEoDjIyLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZUdyb3VwLk5hcnJhdGl2ZVR5cGUSGAoQdGltZV96b25lX29mZnNldBgFIAEoARIWCgluYXJyYXRpdmUYBiABKAlIAYgBARIoCgR0YWdzGAcgAygLMhoud2lzZXRpbWUudXNlci50eXBlLlRhZ1JlZhI2Cg50b3RhbF9kdXJhdGlvbhgJIAEoCzIZLmdvb2dsZS5wcm90b2J1Zi5EdXJhdGlvbkgCiAEBQgcKBV9uYW1lQgwKCl9uYXJyYXRpdmVCEQoPX3RvdGFsX2R1cmF0aW9uSgQIAxAESgQICBAJUgVjb2xvclIOYWN0aXZpdHlfdHlwZXMimAcKCVRpbWVHcm91cBIKCgJpZBgBIAEoCRIRCgluYXJyYXRpdmUYBCABKAkSSgoObmFycmF0aXZlX3R5cGUYBSABKA4yMi53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVHcm91cC5OYXJyYXRpdmVUeXBlEhgKDHRpbWVfcm93X2lkcxgGIAMoCUICGAESKAoEdGFncxgHIAMoCzIaLndpc2V0aW1lLnVzZXIudHlwZS5UYWdSZWYSOgoOdGFnX2NhdGVnb3JpZXMYCiADKAsyIi53aXNldGltZS51c2VyLnR5cGUuVGFnQ2F0ZWdvcnlSZWYSWgogc2VsZWN0ZWRfdGltZXNoZWV0X2ZpZWxkX29wdGlvbnMYESADKAsyMC53aXNldGltZS51c2VyLnR5cGUuU2VsZWN0ZWRUaW1lc2hlZXRGaWVsZE9wdGlvbhIvCgtjcmVhdGVfdGltZRgPIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFQoNYWN0aXZpdHlfZGF0ZRgLIAEoCRI6Cgtwb3N0X3N0YXR1cxgMIAEoDjIlLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuUG9zdFN0YXR1cxIZChFwb3N0ZWRfdG9fc2l0ZV9pZBgNIAEoCRIVCg1lcnJvcl9tZXNzYWdlGA4gASgJEjEKDnRvdGFsX2R1cmF0aW9uGAkgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uEkQKBnNvdXJjZRgQIAEoDjI0Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZUdyb3VwLlRpbWVHcm91cFNvdXJjZSJsCg1OYXJyYXRpdmVUeXBlEh4KGk5BUlJBVElWRV9UWVBFX1VOU1BFQ0lGSUVEEAASEgoOTkFSUkFUSVZFX09OTFkQARInCiNOQVJSQVRJVkVfQU5EX1RJTUVfUk9XX0RFU0NSSVBUSU9OUxACIngKD1RpbWVHcm91cFNvdXJjZRIfChtUSU1FX0dST1VQX1NPVVJDRV9VTkRFRklORUQQABIiCh5USU1FX0dST1VQX1NPVVJDRV9VU0VSX0NSRUFURUQQARIgChxUSU1FX0dST1VQX1NPVVJDRV9CTE9DS19QT1NUEAJKBAgDEARKBAgIEAlKBAgCEANSBWNvbG9yUg5hY3Rpdml0eV90eXBlc1IEbmFtZSJEChVBZGRUb1RpbWVHcm91cFJlcXVlc3QSFAoMdGltZV9yb3dfaWRzGAEgAygJEhUKDXRpbWVfZ3JvdXBfaWQYAiABKAkiSQoaUmVtb3ZlRnJvbVRpbWVHcm91cFJlcXVlc3QSFAoMdGltZV9yb3dfaWRzGAEgAygJEhUKDXRpbWVfZ3JvdXBfaWQYAiABKAkiagoeVXBkYXRlVGltZUdyb3VwRHVyYXRpb25SZXF1ZXN0EhUKDXRpbWVfZ3JvdXBfaWQYASABKAkSMQoOdG90YWxfZHVyYXRpb24YBiABKAsyGS5nb29nbGUucHJvdG9idWYuRHVyYXRpb24ilQEKFlVwZGF0ZVRpbWVHcm91cFJlcXVlc3QSCgoCaWQYASABKAkSPgoKdGltZV9ncm91cBgCIAEoCzIqLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZUdyb3VwVXBkYXRlEi8KC3VwZGF0ZV9tYXNrGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayLCAQoPVGltZUdyb3VwVXBkYXRlEhEKCW5hcnJhdGl2ZRgCIAEoCRJKCg5uYXJyYXRpdmVfdHlwZRgDIAEoDjIyLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZUdyb3VwLk5hcnJhdGl2ZVR5cGUSRAoQbmFycmF0aXZlX3NvdXJjZRgEIAEoDjIqLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuTmFycmF0aXZlU291cmNlSgQIARACUgRuYW1lIksKFkRlbGV0ZVRpbWVHcm91cFJlcXVlc3QSFgoOdGltZV9ncm91cF9pZHMYAiADKAkSGQoNdGltZV9ncm91cF9pZBgBIAEoCUICGAEiigEKG0NyZWF0ZVRpbWVsaW5lTWFya2VyUmVxdWVzdBITCgtkZXNjcmlwdGlvbhgBIAEoCRIMCgRkYXRlGAIgASgJEi4KCnN0YXJ0X3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhgKEHRpbWVfem9uZV9vZmZzZXQYBCABKAEiKQobRGVsZXRlVGltZWxpbmVNYXJrZXJSZXF1ZXN0EgoKAmlkGAEgASgJIloKFEFkZE1hbnVhbFRpbWVSZXF1ZXN0EkIKEG1hbnVhbF90aW1lX3Jvd3MYAiADKAsyKC53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0Lk1hbnVhbFRpbWVSb3ci1QMKDU1hbnVhbFRpbWVSb3cSFQoNYWN0aXZpdHlfaG91chgBIAEoDRIPCgdtaW51dGVzGAIgASgNEhMKC2Rlc2NyaXB0aW9uGAMgASgJEhEKCXRpbWVfem9uZRgFIAEoCRIYChB0aW1lX3pvbmVfb2Zmc2V0GAYgASgBEk0KCGNhdGVnb3J5GAcgASgOMjsud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5NYW51YWxUaW1lUm93Lk1hbnVhbFRpbWVDYXRlZ29yeSL1AQoSTWFudWFsVGltZUNhdGVnb3J5EiQKIE1BTlVBTF9USU1FX0NBVEVHT1JZX1VOU1BFQ0lGSUVEEAASCQoFT1RIRVIQARIPCgdSRUFESU5HEAIaAggBEgoKBlRSQVZFTBADEg4KClZJREVPX0NBTEwQBBIOCgpQSE9ORV9DQUxMEAUSCwoHTUVFVElORxAGEhAKCFRISU5LSU5HEAcaAggBEhIKClBBUEVSX1dPUksQCBoCCAESDAoIT05fTEVBVkUQCRIPCgtSRVNFQVJDSElORxAKEgwKCERSQUZUSU5HEAsSEQoNQ09SUkVTUE9ORElORxAMSgQIBBAFUg1hY3Rpdml0eV90eXBlIjEKFUFkZE1hbnVhbFRpbWVSZXNwb25zZRIYChBuZXdfdGltZV9yb3dfaWRzGAEgAygJIjUKG0NsZWFyVGltZUdyb3VwRXJyb3JzUmVxdWVzdBIWCg50aW1lX2dyb3VwX2lkcxgBIAMoCSJeChxDbGVhclRpbWVHcm91cEVycm9yc1Jlc3BvbnNlEh8KF2FmZmVjdGVkX3RpbWVfZ3JvdXBfaWRzGAEgAygJEh0KFWFmZmVjdGVkX3RpbWVfcm93X2lkcxgCIAMoCSLkBQoHVGltZVJvdxIKCgJpZBgBIAEoCRIVCg10aW1lX2dyb3VwX2lkGAIgASgJEhAKCGFjdGl2aXR5GAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEhAKCGljb25fdXJsGAUgASgJEisKCGR1cmF0aW9uGAcgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uEhUKDWFjdGl2aXR5X2RhdGUYFiABKAkSFQoNYWN0aXZpdHlfaG91chgIIAEoDRIeChZmaXJzdF9vYnNlcnZlZF9pbl9ob3VyGAkgASgFEhEKCXRpbWVfem9uZRgKIAEoCRIYChB0aW1lX3pvbmVfb2Zmc2V0GAsgASgBEigKBHRhZ3MYDCADKAsyGi53aXNldGltZS51c2VyLnR5cGUuVGFnUmVmEjoKDnRhZ19jYXRlZ29yaWVzGBUgAygLMiIud2lzZXRpbWUudXNlci50eXBlLlRhZ0NhdGVnb3J5UmVmEkEKD3RhZ19zdWdnZXN0aW9ucxgNIAMoCzIoLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGFnU3VnZ2VzdGlvbhJaCiBzZWxlY3RlZF90aW1lc2hlZXRfZmllbGRfb3B0aW9ucxgXIAMoCzIwLndpc2V0aW1lLnVzZXIudHlwZS5TZWxlY3RlZFRpbWVzaGVldEZpZWxkT3B0aW9uEjwKDHRyYXNoX3N0YXR1cxgSIAEoDjImLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVHJhc2hTdGF0dXNKBAgTEBRKBAgQEBFKBAgPEBBKBAgREBJKBAgUEBVKBAgGEAdKBAgOEA9SC2NyZWF0ZV90aW1lUhFwb3N0ZWRfdG9fc2l0ZV9pZFILcG9zdF9zdGF0dXNSDWVycm9yX21lc3NhZ2VSEmFzc29jaWF0ZWRfdXNlcl9pZFIIbWV0YWRhdGFSDmFjdGl2aXR5X3R5cGVzIkQKDVRhZ1N1Z2dlc3Rpb24SCgoCaWQYASABKAkSJwoDdGFnGAIgASgLMhoud2lzZXRpbWUudXNlci50eXBlLlRhZ1JlZiLzAQoOVGltZWxpbmVNYXJrZXISCgoCaWQYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkSDAoEZGF0ZRgDIAEoCRIuCgpzdGFydF90aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIxCghlbmRfdGltZRgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARIYChB0aW1lX3pvbmVfb2Zmc2V0GAYgASgBEigKBHRhZ3MYByADKAsyGi53aXNldGltZS51c2VyLnR5cGUuVGFnUmVmQgsKCV9lbmRfdGltZSKKAgocQ291bnRGaWx0ZXJlZFRpbWVSb3dzUmVxdWVzdBISCgpzdGFydF9kYXRlGAEgASgJEhAKCGVuZF9kYXRlGAIgASgJEk4KBmZpbHRlchgEIAEoCzI+Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ291bnRGaWx0ZXJlZFRpbWVSb3dzUmVxdWVzdC5GaWx0ZXIaXAoGRmlsdGVyEhIKCmFjdGl2aXRpZXMYASADKAkSFAoMZGVzY3JpcHRpb25zGAIgAygJEg8KB3RhZ19pZHMYAyADKAlKBAgEEAVSEWFjdGl2aXR5X3R5cGVfaWRzSgQIAxAEUhB0aW1lX3pvbmVfb2Zmc2V0Iq4BCh1Db3VudEZpbHRlcmVkVGltZVJvd3NSZXNwb25zZRJbCgpkYXlfY291bnRzGAEgAygLMkcud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5Db3VudEZpbHRlcmVkVGltZVJvd3NSZXNwb25zZS5EYXlDb3VudHNFbnRyeRowCg5EYXlDb3VudHNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKA06AjgBIjAKFk1lcmdlVGltZUdyb3Vwc1JlcXVlc3QSFgoOdGltZV9ncm91cF9pZHMYASADKAkqTwoPTmFycmF0aXZlU291cmNlEiAKHE5BUlJBVElWRV9TT1VSQ0VfVU5TUEVDSUZJRUQQABIICgRVU0VSEAESEAoMQUlfR0VORVJBVEVEEAIqbQoKUG9zdFN0YXR1cxIOCgpOT1RfUE9TVEVEEAASCwoHUEVORElORxABEhUKEVRSQU5TSUVOVF9GQUlMVVJFEAISCgoGRkFJTEVEEAMSCwoHU1VDQ0VTUxAFIgQIBBAEKgxBQ0tOT1dMRURHRUQqKwoLVHJhc2hTdGF0dXMSDwoLTk9UX1RSQVNIRUQQABILCgdUUkFTSEVEEAEyzx8KD1RpbWVsaW5lU2VydmljZRJyCg1MaXN0VGltZWxpbmVzEi8ud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5MaXN0VGltZWxpbmVzUmVxdWVzdBowLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuTGlzdFRpbWVsaW5lc1Jlc3BvbnNlEo4BChFHZXRUaW1lbGluZVN0YXR1cxIzLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuR2V0VGltZWxpbmVTdGF0dXNSZXF1ZXN0GiIud2lzZXRpbWUudXNlci50eXBlLlRpbWVsaW5lU3RhdHVzIiCC0+STAhoSGC9hcGkvdjQvdGltZWxpbmVzL3N0YXR1cxJ7ChBMaXN0RGF5U3VtbWFyaWVzEjIud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5MaXN0RGF5U3VtbWFyaWVzUmVxdWVzdBozLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuTGlzdERheVN1bW1hcmllc1Jlc3BvbnNlEoEBChJMaXN0VGltZVJvd3NCeURhdGUSNC53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0Lkxpc3RUaW1lUm93c0J5RGF0ZVJlcXVlc3QaNS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0Lkxpc3RUaW1lUm93c0J5RGF0ZVJlc3BvbnNlEnsKFFdhdGNoVGltZWxpbmVVcGRhdGVzEjYud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5XYXRjaFRpbWVsaW5lVXBkYXRlc1JlcXVlc3QaKS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVsaW5lVXBkYXRlMAESYwoIUG9zdFRpbWUSKi53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlBvc3RUaW1lUmVxdWVzdBorLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuUG9zdFRpbWVSZXNwb25zZRJ1Cg5DYW5jZWxQb3N0VGltZRIwLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ2FuY2VsUG9zdFRpbWVSZXF1ZXN0GjEud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5DYW5jZWxQb3N0VGltZVJlc3BvbnNlEmYKCUF0dGFjaFRhZxIrLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQXR0YWNoVGFnUmVxdWVzdBosLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQXR0YWNoVGFnUmVzcG9uc2USZgoJRGV0YWNoVGFnEisud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5EZXRhY2hUYWdSZXF1ZXN0Giwud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5EZXRhY2hUYWdSZXNwb25zZRJ+ChFEZXRhY2hUYWdDYXRlZ29yeRIzLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuRGV0YWNoVGFnQ2F0ZWdvcnlSZXF1ZXN0GjQud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5EZXRhY2hUYWdDYXRlZ29yeVJlc3BvbnNlEoQBChNBY2NlcHRUYWdTdWdnZXN0aW9uEjUud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5BY2NlcHRUYWdTdWdnZXN0aW9uUmVxdWVzdBo2Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQWNjZXB0VGFnU3VnZ2VzdGlvblJlc3BvbnNlEocBChREZWNsaW5lVGFnU3VnZ2VzdGlvbhI2Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuRGVjbGluZVRhZ1N1Z2dlc3Rpb25SZXF1ZXN0Gjcud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5EZWNsaW5lVGFnU3VnZ2VzdGlvblJlc3BvbnNlEoABChpTZWxlY3RUaW1lc2hlZXRGaWVsZE9wdGlvbhI8Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuU2VsZWN0VGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0GiQud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lR3JvdXAScgoTQ2xlYXJUaW1lc2hlZXRGaWVsZBI1Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ2xlYXJUaW1lc2hlZXRGaWVsZFJlcXVlc3QaJC53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVHcm91cBKiAQodU2VsZWN0Um93VGltZXNoZWV0RmllbGRPcHRpb24SPy53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlNlbGVjdFJvd1RpbWVzaGVldEZpZWxkT3B0aW9uUmVxdWVzdBpALndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuU2VsZWN0Um93VGltZXNoZWV0RmllbGRPcHRpb25SZXNwb25zZRKNAQoWQ2xlYXJSb3dUaW1lc2hlZXRGaWVsZBI4Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ2xlYXJSb3dUaW1lc2hlZXRGaWVsZFJlcXVlc3QaOS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkNsZWFyUm93VGltZXNoZWV0RmllbGRSZXNwb25zZRJyCg1UcmFzaFRpbWVSb3dzEi8ud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UcmFzaFRpbWVSb3dzUmVxdWVzdBowLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVHJhc2hUaW1lUm93c1Jlc3BvbnNlEngKD1VuVHJhc2hUaW1lUm93cxIxLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVW5UcmFzaFRpbWVSb3dzUmVxdWVzdBoyLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVW5UcmFzaFRpbWVSb3dzUmVzcG9uc2USlgEKGUltbWVkaWF0ZWx5RGVsZXRlVGltZVJvd3MSOy53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkltbWVkaWF0ZWx5RGVsZXRlVGltZVJvd3NSZXF1ZXN0Gjwud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5JbW1lZGlhdGVseURlbGV0ZVRpbWVSb3dzUmVzcG9uc2USaQoKRW1wdHlUcmFzaBIsLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuRW1wdHlUcmFzaFJlcXVlc3QaLS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkVtcHR5VHJhc2hSZXNwb25zZRJqCg9DcmVhdGVUaW1lR3JvdXASMS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkNyZWF0ZVRpbWVHcm91cFJlcXVlc3QaJC53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlRpbWVHcm91cBJ0ChRDcmVhdGVFbXB0eVRpbWVHcm91cBI2Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ3JlYXRlRW1wdHlUaW1lR3JvdXBSZXF1ZXN0GiQud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lR3JvdXASaAoOQWRkVG9UaW1lR3JvdXASMC53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkFkZFRvVGltZUdyb3VwUmVxdWVzdBokLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZUdyb3VwEnIKE1JlbW92ZUZyb21UaW1lR3JvdXASNS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlJlbW92ZUZyb21UaW1lR3JvdXBSZXF1ZXN0GiQud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lR3JvdXASagoPVXBkYXRlVGltZUdyb3VwEjEud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5VcGRhdGVUaW1lR3JvdXBSZXF1ZXN0GiQud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lR3JvdXASegoXVXBkYXRlVGltZUdyb3VwRHVyYXRpb24SOS53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LlVwZGF0ZVRpbWVHcm91cER1cmF0aW9uUmVxdWVzdBokLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuVGltZUdyb3VwElwKD0RlbGV0ZVRpbWVHcm91cBIxLndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuRGVsZXRlVGltZUdyb3VwUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJ5ChRDcmVhdGVUaW1lbGluZU1hcmtlchI2Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ3JlYXRlVGltZWxpbmVNYXJrZXJSZXF1ZXN0Gikud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lbGluZU1hcmtlchJmChREZWxldGVUaW1lbGluZU1hcmtlchI2Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuRGVsZXRlVGltZWxpbmVNYXJrZXJSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5EnIKDUFkZE1hbnVhbFRpbWUSLy53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkFkZE1hbnVhbFRpbWVSZXF1ZXN0GjAud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5BZGRNYW51YWxUaW1lUmVzcG9uc2USigEKFUNvdW50RmlsdGVyZWRUaW1lUm93cxI3Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ291bnRGaWx0ZXJlZFRpbWVSb3dzUmVxdWVzdBo4Lndpc2V0aW1lLnVzZXIudGltZWxpbmUudjQuQ291bnRGaWx0ZXJlZFRpbWVSb3dzUmVzcG9uc2UShwEKFENsZWFyVGltZUdyb3VwRXJyb3JzEjYud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5DbGVhclRpbWVHcm91cEVycm9yc1JlcXVlc3QaNy53aXNldGltZS51c2VyLnRpbWVsaW5lLnY0LkNsZWFyVGltZUdyb3VwRXJyb3JzUmVzcG9uc2USagoPTWVyZ2VUaW1lR3JvdXBzEjEud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5NZXJnZVRpbWVHcm91cHNSZXF1ZXN0GiQud2lzZXRpbWUudXNlci50aW1lbGluZS52NC5UaW1lR3JvdXBCOwohY29tLndpc2V0aW1lLmFwaS51c2VyLnRpbWVsaW5lLnY0QhRUaW1lbGluZVNlcnZpY2VQcm90b1ABYgZwcm90bzM", [file_google_api_annotations, file_google_protobuf_duration, file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_wisetime_type_site_ref, file_wisetime_user_type_selected_timesheet_field_option, file_wisetime_user_type_tag_ref, file_wisetime_user_type_tag_category_ref, file_wisetime_user_type_timeline_status]);

/**
 * @generated from message wisetime.user.timeline.v4.ListTimelinesRequest
 */
export type ListTimelinesRequest = Message<"wisetime.user.timeline.v4.ListTimelinesRequest"> & {
  /**
   * Start and end dates are inclusive. Use format yyyyMMdd.
   *
   * @generated from field: string start_date = 1;
   */
  startDate: string;

  /**
   * @generated from field: string end_date = 2;
   */
  endDate: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.ListTimelinesRequest.
 * Use `create(ListTimelinesRequestSchema)` to create a new message.
 */
export const ListTimelinesRequestSchema: GenMessage<ListTimelinesRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 0);

/**
 * @generated from message wisetime.user.timeline.v4.ListTimelinesResponse
 */
export type ListTimelinesResponse = Message<"wisetime.user.timeline.v4.ListTimelinesResponse"> & {
  /**
   * One timeline per day.
   * Timelines will still be returned for dates that don't have any recorded time rows or time groups.
   * The respective row and group lists will simply be empty.
   *
   * @generated from field: repeated wisetime.user.timeline.v4.Timeline timelines = 1;
   */
  timelines: Timeline[];
};

/**
 * Describes the message wisetime.user.timeline.v4.ListTimelinesResponse.
 * Use `create(ListTimelinesResponseSchema)` to create a new message.
 */
export const ListTimelinesResponseSchema: GenMessage<ListTimelinesResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 1);

/**
 * @generated from message wisetime.user.timeline.v4.Timeline
 */
export type Timeline = Message<"wisetime.user.timeline.v4.Timeline"> & {
  /**
   * The date will be set if the message represents the full time row and time group dataset for a single day.
   * Format: yyyyMMdd
   *
   * @generated from field: string date = 5;
   */
  date: string;

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TimeRow time_rows_in_range = 2;
   */
  timeRowsInRange: TimeRow[];

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TimeGroup time_groups_in_range = 1;
   */
  timeGroupsInRange: TimeGroup[];

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TimelineMarker markers = 6;
   */
  markers: TimelineMarker[];
};

/**
 * Describes the message wisetime.user.timeline.v4.Timeline.
 * Use `create(TimelineSchema)` to create a new message.
 */
export const TimelineSchema: GenMessage<Timeline> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 2);

/**
 * @generated from message wisetime.user.timeline.v4.GetTimelineStatusRequest
 */
export type GetTimelineStatusRequest = Message<"wisetime.user.timeline.v4.GetTimelineStatusRequest"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.GetTimelineStatusRequest.
 * Use `create(GetTimelineStatusRequestSchema)` to create a new message.
 */
export const GetTimelineStatusRequestSchema: GenMessage<GetTimelineStatusRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 3);

/**
 * @generated from message wisetime.user.timeline.v4.ListDaySummariesRequest
 */
export type ListDaySummariesRequest = Message<"wisetime.user.timeline.v4.ListDaySummariesRequest"> & {
  /**
   * Start of range, inclusive. Format: yyyyMMdd
   *
   * @generated from field: string start_date = 1;
   */
  startDate: string;

  /**
   * End of range, inclusive. Format: yyyyMMdd
   *
   * @generated from field: string end_date = 2;
   */
  endDate: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.ListDaySummariesRequest.
 * Use `create(ListDaySummariesRequestSchema)` to create a new message.
 */
export const ListDaySummariesRequestSchema: GenMessage<ListDaySummariesRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 4);

/**
 * @generated from message wisetime.user.timeline.v4.ListDaySummariesResponse
 */
export type ListDaySummariesResponse = Message<"wisetime.user.timeline.v4.ListDaySummariesResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.timeline.v4.DaySummary day_summaries = 1;
   */
  daySummaries: DaySummary[];
};

/**
 * Describes the message wisetime.user.timeline.v4.ListDaySummariesResponse.
 * Use `create(ListDaySummariesResponseSchema)` to create a new message.
 */
export const ListDaySummariesResponseSchema: GenMessage<ListDaySummariesResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 5);

/**
 * @generated from message wisetime.user.timeline.v4.DaySummary
 */
export type DaySummary = Message<"wisetime.user.timeline.v4.DaySummary"> & {
  /**
   * Format: yyyyMMdd
   *
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: google.protobuf.Duration total_unposted = 3;
   */
  totalUnposted?: Duration;

  /**
   * @generated from field: bool has_error = 5;
   */
  hasError: boolean;

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.DaySummary.TimePostedToSite time_posted_to_site = 6;
   */
  timePostedToSite: DaySummary_TimePostedToSite[];
};

/**
 * Describes the message wisetime.user.timeline.v4.DaySummary.
 * Use `create(DaySummarySchema)` to create a new message.
 */
export const DaySummarySchema: GenMessage<DaySummary> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 6);

/**
 * @generated from message wisetime.user.timeline.v4.DaySummary.TimePostedToSite
 */
export type DaySummary_TimePostedToSite = Message<"wisetime.user.timeline.v4.DaySummary.TimePostedToSite"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: google.protobuf.Duration total_posted = 2;
   */
  totalPosted?: Duration;
};

/**
 * Describes the message wisetime.user.timeline.v4.DaySummary.TimePostedToSite.
 * Use `create(DaySummary_TimePostedToSiteSchema)` to create a new message.
 */
export const DaySummary_TimePostedToSiteSchema: GenMessage<DaySummary_TimePostedToSite> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 6, 0);

/**
 * @generated from message wisetime.user.timeline.v4.ListTimeRowsByDateRequest
 */
export type ListTimeRowsByDateRequest = Message<"wisetime.user.timeline.v4.ListTimeRowsByDateRequest"> & {
  /**
   * Format yyyyMMdd, inclusive.
   *
   * @generated from field: uint32 start_activity_date = 1;
   */
  startActivityDate: number;

  /**
   * Format yyyyMMdd, inclusive.
   *
   * @generated from field: uint32 end_activity_date = 2;
   */
  endActivityDate: number;

  /**
   * If set, only return time rows matching these statuses.
   *
   * @generated from field: optional wisetime.user.timeline.v4.PostStatus post_status = 3;
   */
  postStatus?: PostStatus;

  /**
   * @generated from field: optional wisetime.user.timeline.v4.TrashStatus trash_status = 4;
   */
  trashStatus?: TrashStatus;
};

/**
 * Describes the message wisetime.user.timeline.v4.ListTimeRowsByDateRequest.
 * Use `create(ListTimeRowsByDateRequestSchema)` to create a new message.
 */
export const ListTimeRowsByDateRequestSchema: GenMessage<ListTimeRowsByDateRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 7);

/**
 * @generated from message wisetime.user.timeline.v4.ListTimeRowsByDateResponse
 */
export type ListTimeRowsByDateResponse = Message<"wisetime.user.timeline.v4.ListTimeRowsByDateResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TimeRow time_rows = 1;
   */
  timeRows: TimeRow[];
};

/**
 * Describes the message wisetime.user.timeline.v4.ListTimeRowsByDateResponse.
 * Use `create(ListTimeRowsByDateResponseSchema)` to create a new message.
 */
export const ListTimeRowsByDateResponseSchema: GenMessage<ListTimeRowsByDateResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 8);

/**
 * @generated from message wisetime.user.timeline.v4.WatchTimelineUpdatesRequest
 */
export type WatchTimelineUpdatesRequest = Message<"wisetime.user.timeline.v4.WatchTimelineUpdatesRequest"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.
 * Use `create(WatchTimelineUpdatesRequestSchema)` to create a new message.
 */
export const WatchTimelineUpdatesRequestSchema: GenMessage<WatchTimelineUpdatesRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 9);

/**
 * @generated from message wisetime.user.timeline.v4.TimelineUpdate
 */
export type TimelineUpdate = Message<"wisetime.user.timeline.v4.TimelineUpdate"> & {
  /**
   * List of distinct dates matching the activity dates of the new or updated time rows.
   * Format of date: yyyyMMdd
   *
   * @generated from field: repeated string dates_with_updates = 3;
   */
  datesWithUpdates: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.TimelineUpdate.
 * Use `create(TimelineUpdateSchema)` to create a new message.
 */
export const TimelineUpdateSchema: GenMessage<TimelineUpdate> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 10);

/**
 * @generated from message wisetime.user.timeline.v4.PostTimeRequest
 */
export type PostTimeRequest = Message<"wisetime.user.timeline.v4.PostTimeRequest"> & {
  /**
   * @generated from field: wisetime.type.SiteRef site = 1;
   */
  site?: SiteRef;

  /**
   * At least one time group must be provided when posting time.
   *
   * @generated from field: repeated wisetime.user.timeline.v4.PostTimeGroup time_groups = 3;
   */
  timeGroups: PostTimeGroup[];
};

/**
 * Describes the message wisetime.user.timeline.v4.PostTimeRequest.
 * Use `create(PostTimeRequestSchema)` to create a new message.
 */
export const PostTimeRequestSchema: GenMessage<PostTimeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 11);

/**
 * @generated from message wisetime.user.timeline.v4.CancelPostTimeRequest
 */
export type CancelPostTimeRequest = Message<"wisetime.user.timeline.v4.CancelPostTimeRequest"> & {
  /**
   * @generated from field: repeated string time_group_ids = 1;
   */
  timeGroupIds: string[];

  /**
   * If a row is part of a time group, will attempt to cancel the entire time group.
   *
   * @generated from field: repeated string time_row_ids = 2;
   */
  timeRowIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.CancelPostTimeRequest.
 * Use `create(CancelPostTimeRequestSchema)` to create a new message.
 */
export const CancelPostTimeRequestSchema: GenMessage<CancelPostTimeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 12);

/**
 * @generated from message wisetime.user.timeline.v4.CancelPostTimeResponse
 */
export type CancelPostTimeResponse = Message<"wisetime.user.timeline.v4.CancelPostTimeResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.CancelPostTimeResponse.
 * Use `create(CancelPostTimeResponseSchema)` to create a new message.
 */
export const CancelPostTimeResponseSchema: GenMessage<CancelPostTimeResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 13);

/**
 * @generated from message wisetime.user.timeline.v4.PostTimeGroup
 */
export type PostTimeGroup = Message<"wisetime.user.timeline.v4.PostTimeGroup"> & {
  /**
   * @generated from field: string time_group_id = 1;
   */
  timeGroupId: string;

  /**
   * Provide the following time group state so that the service can verify that the time group
   * is being posted with the state that the user expects. I.e. guard against the frontend being
   * out of sync with the backend.
   *
   * @generated from field: repeated wisetime.user.type.TagRef tags = 2;
   */
  tags: TagRef[];

  /**
   * @generated from field: repeated wisetime.user.type.SelectedTimesheetFieldOption selected_timesheet_field_options = 6;
   */
  selectedTimesheetFieldOptions: SelectedTimesheetFieldOption[];

  /**
   * @generated from field: google.protobuf.Duration total_duration = 4;
   */
  totalDuration?: Duration;

  /**
   * this should be the rounded value of duration as was displayed to the user
   *
   * @generated from field: google.protobuf.Duration rounded_total_duration = 5;
   */
  roundedTotalDuration?: Duration;
};

/**
 * Describes the message wisetime.user.timeline.v4.PostTimeGroup.
 * Use `create(PostTimeGroupSchema)` to create a new message.
 */
export const PostTimeGroupSchema: GenMessage<PostTimeGroup> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 14);

/**
 * @generated from message wisetime.user.timeline.v4.PostTimeResponse
 */
export type PostTimeResponse = Message<"wisetime.user.timeline.v4.PostTimeResponse"> & {
  /**
   * @generated from field: string posted_to_site_id = 4;
   */
  postedToSiteId: string;

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult time_row_results = 1;
   */
  timeRowResults: PostTimeResponse_TimeRowResult[];

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult time_group_results = 3;
   */
  timeGroupResults: PostTimeResponse_TimeGroupResult[];

  /**
   * @generated from field: google.protobuf.Duration remaining_user_unposted_time = 2;
   */
  remainingUserUnpostedTime?: Duration;
};

/**
 * Describes the message wisetime.user.timeline.v4.PostTimeResponse.
 * Use `create(PostTimeResponseSchema)` to create a new message.
 */
export const PostTimeResponseSchema: GenMessage<PostTimeResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 15);

/**
 * @generated from message wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult
 */
export type PostTimeResponse_TimeRowResult = Message<"wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult"> & {
  /**
   * @generated from field: string time_row_id = 1;
   */
  timeRowId: string;

  /**
   * @generated from field: wisetime.user.timeline.v4.PostStatus status = 3;
   */
  status: PostStatus;

  /**
   * An error message will be provided if time posting fails immediately.
   *
   * @generated from field: optional string error_message = 4;
   */
  errorMessage?: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.
 * Use `create(PostTimeResponse_TimeRowResultSchema)` to create a new message.
 */
export const PostTimeResponse_TimeRowResultSchema: GenMessage<PostTimeResponse_TimeRowResult> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 15, 0);

/**
 * @generated from message wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult
 */
export type PostTimeResponse_TimeGroupResult = Message<"wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult"> & {
  /**
   * @generated from field: string time_group_id = 1;
   */
  timeGroupId: string;

  /**
   * @generated from field: wisetime.user.timeline.v4.PostStatus status = 2;
   */
  status: PostStatus;

  /**
   * An error message will be provided if time posting fails immediately.
   *
   * @generated from field: optional string error_message = 3;
   */
  errorMessage?: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.
 * Use `create(PostTimeResponse_TimeGroupResultSchema)` to create a new message.
 */
export const PostTimeResponse_TimeGroupResultSchema: GenMessage<PostTimeResponse_TimeGroupResult> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 15, 1);

/**
 * A wrapped list of IDs. Useful since oneof fields don't support repeated fields.
 *
 * @generated from message wisetime.user.timeline.v4.IdList
 */
export type IdList = Message<"wisetime.user.timeline.v4.IdList"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.IdList.
 * Use `create(IdListSchema)` to create a new message.
 */
export const IdListSchema: GenMessage<IdList> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 16);

/**
 * @generated from message wisetime.user.timeline.v4.AttachTagRequest
 */
export type AttachTagRequest = Message<"wisetime.user.timeline.v4.AttachTagRequest"> & {
  /**
   * @generated from oneof wisetime.user.timeline.v4.AttachTagRequest.ids
   */
  ids: {
    /**
     * @generated from field: wisetime.user.timeline.v4.IdList time_row_ids = 1;
     */
    value: IdList;
    case: "timeRowIds";
  } | {
    /**
     * @generated from field: wisetime.user.timeline.v4.IdList time_group_ids = 5;
     */
    value: IdList;
    case: "timeGroupIds";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string tag_id = 4;
   */
  tagId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.AttachTagRequest.
 * Use `create(AttachTagRequestSchema)` to create a new message.
 */
export const AttachTagRequestSchema: GenMessage<AttachTagRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 17);

/**
 * @generated from message wisetime.user.timeline.v4.AttachTagResponse
 */
export type AttachTagResponse = Message<"wisetime.user.timeline.v4.AttachTagResponse"> & {
  /**
   * Updated entities (typically matches ids from request).
   *
   * @generated from field: repeated wisetime.user.timeline.v4.TimeGroup time_groups = 1;
   */
  timeGroups: TimeGroup[];

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TimeRow time_rows = 2;
   */
  timeRows: TimeRow[];
};

/**
 * Describes the message wisetime.user.timeline.v4.AttachTagResponse.
 * Use `create(AttachTagResponseSchema)` to create a new message.
 */
export const AttachTagResponseSchema: GenMessage<AttachTagResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 18);

/**
 * @generated from message wisetime.user.timeline.v4.DetachTagRequest
 */
export type DetachTagRequest = Message<"wisetime.user.timeline.v4.DetachTagRequest"> & {
  /**
   * @generated from oneof wisetime.user.timeline.v4.DetachTagRequest.target
   */
  target: {
    /**
     * @generated from field: wisetime.user.timeline.v4.IdList time_row_ids = 1;
     */
    value: IdList;
    case: "timeRowIds";
  } | {
    /**
     * @generated from field: string time_group_id = 2;
     */
    value: string;
    case: "timeGroupId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string tag_id = 4;
   */
  tagId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.DetachTagRequest.
 * Use `create(DetachTagRequestSchema)` to create a new message.
 */
export const DetachTagRequestSchema: GenMessage<DetachTagRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 19);

/**
 * @generated from message wisetime.user.timeline.v4.DetachTagResponse
 */
export type DetachTagResponse = Message<"wisetime.user.timeline.v4.DetachTagResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.DetachTagResponse.
 * Use `create(DetachTagResponseSchema)` to create a new message.
 */
export const DetachTagResponseSchema: GenMessage<DetachTagResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 20);

/**
 * @generated from message wisetime.user.timeline.v4.DetachTagCategoryRequest
 */
export type DetachTagCategoryRequest = Message<"wisetime.user.timeline.v4.DetachTagCategoryRequest"> & {
  /**
   * @generated from oneof wisetime.user.timeline.v4.DetachTagCategoryRequest.target
   */
  target: {
    /**
     * @generated from field: wisetime.user.timeline.v4.IdList time_row_ids = 1;
     */
    value: IdList;
    case: "timeRowIds";
  } | {
    /**
     * @generated from field: string time_group_id = 2;
     */
    value: string;
    case: "timeGroupId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string tag_category_id = 3;
   */
  tagCategoryId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.DetachTagCategoryRequest.
 * Use `create(DetachTagCategoryRequestSchema)` to create a new message.
 */
export const DetachTagCategoryRequestSchema: GenMessage<DetachTagCategoryRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 21);

/**
 * @generated from message wisetime.user.timeline.v4.DetachTagCategoryResponse
 */
export type DetachTagCategoryResponse = Message<"wisetime.user.timeline.v4.DetachTagCategoryResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.DetachTagCategoryResponse.
 * Use `create(DetachTagCategoryResponseSchema)` to create a new message.
 */
export const DetachTagCategoryResponseSchema: GenMessage<DetachTagCategoryResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 22);

/**
 * @generated from message wisetime.user.timeline.v4.AcceptTagSuggestionRequest
 */
export type AcceptTagSuggestionRequest = Message<"wisetime.user.timeline.v4.AcceptTagSuggestionRequest"> & {
  /**
   * @generated from field: string tag_suggestion_id = 1;
   */
  tagSuggestionId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.AcceptTagSuggestionRequest.
 * Use `create(AcceptTagSuggestionRequestSchema)` to create a new message.
 */
export const AcceptTagSuggestionRequestSchema: GenMessage<AcceptTagSuggestionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 23);

/**
 * @generated from message wisetime.user.timeline.v4.AcceptTagSuggestionResponse
 */
export type AcceptTagSuggestionResponse = Message<"wisetime.user.timeline.v4.AcceptTagSuggestionResponse"> & {
  /**
   * Time rows updated as a result of accepting the tag suggestions.
   *
   * @generated from field: repeated wisetime.user.timeline.v4.TimeRow updated_time_rows = 1;
   */
  updatedTimeRows: TimeRow[];
};

/**
 * Describes the message wisetime.user.timeline.v4.AcceptTagSuggestionResponse.
 * Use `create(AcceptTagSuggestionResponseSchema)` to create a new message.
 */
export const AcceptTagSuggestionResponseSchema: GenMessage<AcceptTagSuggestionResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 24);

/**
 * @generated from message wisetime.user.timeline.v4.DeclineTagSuggestionRequest
 */
export type DeclineTagSuggestionRequest = Message<"wisetime.user.timeline.v4.DeclineTagSuggestionRequest"> & {
  /**
   * @generated from field: string tag_suggestion_id = 1;
   */
  tagSuggestionId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.DeclineTagSuggestionRequest.
 * Use `create(DeclineTagSuggestionRequestSchema)` to create a new message.
 */
export const DeclineTagSuggestionRequestSchema: GenMessage<DeclineTagSuggestionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 25);

/**
 * @generated from message wisetime.user.timeline.v4.DeclineTagSuggestionResponse
 */
export type DeclineTagSuggestionResponse = Message<"wisetime.user.timeline.v4.DeclineTagSuggestionResponse"> & {
  /**
   * Time rows updated as a result of declining the tag suggestions.
   *
   * @generated from field: repeated wisetime.user.timeline.v4.TimeRow updated_time_rows = 1;
   */
  updatedTimeRows: TimeRow[];
};

/**
 * Describes the message wisetime.user.timeline.v4.DeclineTagSuggestionResponse.
 * Use `create(DeclineTagSuggestionResponseSchema)` to create a new message.
 */
export const DeclineTagSuggestionResponseSchema: GenMessage<DeclineTagSuggestionResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 26);

/**
 * @generated from message wisetime.user.timeline.v4.SetActivityTypeRequest
 */
export type SetActivityTypeRequest = Message<"wisetime.user.timeline.v4.SetActivityTypeRequest"> & {
  /**
   * @generated from field: wisetime.user.timeline.v4.IdList time_row_ids = 1;
   */
  timeRowIds?: IdList;

  /**
   * @generated from field: string activity_type_id = 3;
   */
  activityTypeId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.SetActivityTypeRequest.
 * Use `create(SetActivityTypeRequestSchema)` to create a new message.
 */
export const SetActivityTypeRequestSchema: GenMessage<SetActivityTypeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 27);

/**
 * @generated from message wisetime.user.timeline.v4.SetActivityTypeResponse
 */
export type SetActivityTypeResponse = Message<"wisetime.user.timeline.v4.SetActivityTypeResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.SetActivityTypeResponse.
 * Use `create(SetActivityTypeResponseSchema)` to create a new message.
 */
export const SetActivityTypeResponseSchema: GenMessage<SetActivityTypeResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 28);

/**
 * @generated from message wisetime.user.timeline.v4.UnsetActivityTypeRequest
 */
export type UnsetActivityTypeRequest = Message<"wisetime.user.timeline.v4.UnsetActivityTypeRequest"> & {
  /**
   * @generated from oneof wisetime.user.timeline.v4.UnsetActivityTypeRequest.target
   */
  target: {
    /**
     * @generated from field: wisetime.user.timeline.v4.IdList time_row_ids = 1;
     */
    value: IdList;
    case: "timeRowIds";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string activity_type_id = 3;
   */
  activityTypeId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.UnsetActivityTypeRequest.
 * Use `create(UnsetActivityTypeRequestSchema)` to create a new message.
 */
export const UnsetActivityTypeRequestSchema: GenMessage<UnsetActivityTypeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 29);

/**
 * @generated from message wisetime.user.timeline.v4.UnsetActivityTypeResponse
 */
export type UnsetActivityTypeResponse = Message<"wisetime.user.timeline.v4.UnsetActivityTypeResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.UnsetActivityTypeResponse.
 * Use `create(UnsetActivityTypeResponseSchema)` to create a new message.
 */
export const UnsetActivityTypeResponseSchema: GenMessage<UnsetActivityTypeResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 30);

/**
 * @generated from message wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest
 */
export type SelectTimesheetFieldOptionRequest = Message<"wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest"> & {
  /**
   * Timesheet entry.
   *
   * @generated from field: string time_group_id = 1;
   */
  timeGroupId: string;

  /**
   * @generated from field: string site_id = 4;
   */
  siteId: string;

  /**
   * Field to set.
   *
   * @generated from field: string timesheet_field_id = 2;
   */
  timesheetFieldId: string;

  /**
   * Selected option.
   *
   * @generated from field: string timesheet_field_option_id = 3;
   */
  timesheetFieldOptionId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.
 * Use `create(SelectTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const SelectTimesheetFieldOptionRequestSchema: GenMessage<SelectTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 31);

/**
 * @generated from message wisetime.user.timeline.v4.ClearTimesheetFieldRequest
 */
export type ClearTimesheetFieldRequest = Message<"wisetime.user.timeline.v4.ClearTimesheetFieldRequest"> & {
  /**
   * Timesheet entry.
   *
   * @generated from field: string time_group_id = 1;
   */
  timeGroupId: string;

  /**
   * @generated from field: string site_id = 3;
   */
  siteId: string;

  /**
   * Field to clear.
   *
   * @generated from field: string timesheet_field_id = 2;
   */
  timesheetFieldId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.ClearTimesheetFieldRequest.
 * Use `create(ClearTimesheetFieldRequestSchema)` to create a new message.
 */
export const ClearTimesheetFieldRequestSchema: GenMessage<ClearTimesheetFieldRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 32);

/**
 * @generated from message wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest
 */
export type SelectRowTimesheetFieldOptionRequest = Message<"wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest"> & {
  /**
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];

  /**
   * @generated from field: string site_id = 4;
   */
  siteId: string;

  /**
   * Field to set.
   *
   * @generated from field: string timesheet_field_id = 2;
   */
  timesheetFieldId: string;

  /**
   * Selected option.
   *
   * @generated from field: string timesheet_field_option_id = 3;
   */
  timesheetFieldOptionId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.
 * Use `create(SelectRowTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const SelectRowTimesheetFieldOptionRequestSchema: GenMessage<SelectRowTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 33);

/**
 * @generated from message wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse
 */
export type SelectRowTimesheetFieldOptionResponse = Message<"wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TimeRow time_rows = 1;
   */
  timeRows: TimeRow[];
};

/**
 * Describes the message wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.
 * Use `create(SelectRowTimesheetFieldOptionResponseSchema)` to create a new message.
 */
export const SelectRowTimesheetFieldOptionResponseSchema: GenMessage<SelectRowTimesheetFieldOptionResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 34);

/**
 * @generated from message wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest
 */
export type ClearRowTimesheetFieldRequest = Message<"wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest"> & {
  /**
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];

  /**
   * @generated from field: string site_id = 3;
   */
  siteId: string;

  /**
   * Field to clear.
   *
   * @generated from field: string timesheet_field_id = 2;
   */
  timesheetFieldId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.
 * Use `create(ClearRowTimesheetFieldRequestSchema)` to create a new message.
 */
export const ClearRowTimesheetFieldRequestSchema: GenMessage<ClearRowTimesheetFieldRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 35);

/**
 * @generated from message wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse
 */
export type ClearRowTimesheetFieldResponse = Message<"wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TimeRow time_rows = 1;
   */
  timeRows: TimeRow[];
};

/**
 * Describes the message wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.
 * Use `create(ClearRowTimesheetFieldResponseSchema)` to create a new message.
 */
export const ClearRowTimesheetFieldResponseSchema: GenMessage<ClearRowTimesheetFieldResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 36);

/**
 * @generated from message wisetime.user.timeline.v4.TrashTimeRowsRequest
 */
export type TrashTimeRowsRequest = Message<"wisetime.user.timeline.v4.TrashTimeRowsRequest"> & {
  /**
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.TrashTimeRowsRequest.
 * Use `create(TrashTimeRowsRequestSchema)` to create a new message.
 */
export const TrashTimeRowsRequestSchema: GenMessage<TrashTimeRowsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 37);

/**
 * @generated from message wisetime.user.timeline.v4.TrashTimeRowsResponse
 */
export type TrashTimeRowsResponse = Message<"wisetime.user.timeline.v4.TrashTimeRowsResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.TrashTimeRowsResponse.
 * Use `create(TrashTimeRowsResponseSchema)` to create a new message.
 */
export const TrashTimeRowsResponseSchema: GenMessage<TrashTimeRowsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 38);

/**
 * @generated from message wisetime.user.timeline.v4.UnTrashTimeRowsRequest
 */
export type UnTrashTimeRowsRequest = Message<"wisetime.user.timeline.v4.UnTrashTimeRowsRequest"> & {
  /**
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.UnTrashTimeRowsRequest.
 * Use `create(UnTrashTimeRowsRequestSchema)` to create a new message.
 */
export const UnTrashTimeRowsRequestSchema: GenMessage<UnTrashTimeRowsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 39);

/**
 * @generated from message wisetime.user.timeline.v4.UnTrashTimeRowsResponse
 */
export type UnTrashTimeRowsResponse = Message<"wisetime.user.timeline.v4.UnTrashTimeRowsResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.UnTrashTimeRowsResponse.
 * Use `create(UnTrashTimeRowsResponseSchema)` to create a new message.
 */
export const UnTrashTimeRowsResponseSchema: GenMessage<UnTrashTimeRowsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 40);

/**
 * @generated from message wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest
 */
export type ImmediatelyDeleteTimeRowsRequest = Message<"wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest"> & {
  /**
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.
 * Use `create(ImmediatelyDeleteTimeRowsRequestSchema)` to create a new message.
 */
export const ImmediatelyDeleteTimeRowsRequestSchema: GenMessage<ImmediatelyDeleteTimeRowsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 41);

/**
 * @generated from message wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse
 */
export type ImmediatelyDeleteTimeRowsResponse = Message<"wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.
 * Use `create(ImmediatelyDeleteTimeRowsResponseSchema)` to create a new message.
 */
export const ImmediatelyDeleteTimeRowsResponseSchema: GenMessage<ImmediatelyDeleteTimeRowsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 42);

/**
 * @generated from message wisetime.user.timeline.v4.EmptyTrashRequest
 */
export type EmptyTrashRequest = Message<"wisetime.user.timeline.v4.EmptyTrashRequest"> & {
};

/**
 * Describes the message wisetime.user.timeline.v4.EmptyTrashRequest.
 * Use `create(EmptyTrashRequestSchema)` to create a new message.
 */
export const EmptyTrashRequestSchema: GenMessage<EmptyTrashRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 43);

/**
 * @generated from message wisetime.user.timeline.v4.EmptyTrashResponse
 */
export type EmptyTrashResponse = Message<"wisetime.user.timeline.v4.EmptyTrashResponse"> & {
  /**
   * @generated from field: uint32 deleted_time_rows_count = 1;
   */
  deletedTimeRowsCount: number;
};

/**
 * Describes the message wisetime.user.timeline.v4.EmptyTrashResponse.
 * Use `create(EmptyTrashResponseSchema)` to create a new message.
 */
export const EmptyTrashResponseSchema: GenMessage<EmptyTrashResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 44);

/**
 * @generated from message wisetime.user.timeline.v4.CreateTimeGroupRequest
 */
export type CreateTimeGroupRequest = Message<"wisetime.user.timeline.v4.CreateTimeGroupRequest"> & {
  /**
   * At least one time row ID must be provided.
   *
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];

  /**
   * @generated from field: wisetime.user.timeline.v4.TimeGroup.NarrativeType narrative_type = 4;
   */
  narrativeType: TimeGroup_NarrativeType;
};

/**
 * Describes the message wisetime.user.timeline.v4.CreateTimeGroupRequest.
 * Use `create(CreateTimeGroupRequestSchema)` to create a new message.
 */
export const CreateTimeGroupRequestSchema: GenMessage<CreateTimeGroupRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 45);

/**
 * @generated from message wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest
 */
export type CreateEmptyTimeGroupRequest = Message<"wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest"> & {
  /**
   * Format: yyyyMMdd
   *
   * @generated from field: string activity_date = 1;
   */
  activityDate: string;

  /**
   * The name of the time group.
   * Empty by default.
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: wisetime.user.timeline.v4.TimeGroup.NarrativeType narrative_type = 4;
   */
  narrativeType: TimeGroup_NarrativeType;

  /**
   * time zone offset from UTC in hours
   * this is used to assign a notional UTC segment hour +/- relative to midday
   *
   * @generated from field: double time_zone_offset = 5;
   */
  timeZoneOffset: number;

  /**
   * @generated from field: optional string narrative = 6;
   */
  narrative?: string;

  /**
   * @generated from field: repeated wisetime.user.type.TagRef tags = 7;
   */
  tags: TagRef[];

  /**
   * @generated from field: optional google.protobuf.Duration total_duration = 9;
   */
  totalDuration?: Duration;
};

/**
 * Describes the message wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.
 * Use `create(CreateEmptyTimeGroupRequestSchema)` to create a new message.
 */
export const CreateEmptyTimeGroupRequestSchema: GenMessage<CreateEmptyTimeGroupRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 46);

/**
 * @generated from message wisetime.user.timeline.v4.TimeGroup
 */
export type TimeGroup = Message<"wisetime.user.timeline.v4.TimeGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string narrative = 4;
   */
  narrative: string;

  /**
   * Narrative type to use when posting the time group.
   *
   * @generated from field: wisetime.user.timeline.v4.TimeGroup.NarrativeType narrative_type = 5;
   */
  narrativeType: TimeGroup_NarrativeType;

  /**
   * @generated from field: repeated string time_row_ids = 6 [deprecated = true];
   * @deprecated
   */
  timeRowIds: string[];

  /**
   * @generated from field: repeated wisetime.user.type.TagRef tags = 7;
   */
  tags: TagRef[];

  /**
   * @generated from field: repeated wisetime.user.type.TagCategoryRef tag_categories = 10;
   */
  tagCategories: TagCategoryRef[];

  /**
   * @generated from field: repeated wisetime.user.type.SelectedTimesheetFieldOption selected_timesheet_field_options = 17;
   */
  selectedTimesheetFieldOptions: SelectedTimesheetFieldOption[];

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 15;
   */
  createTime?: Timestamp;

  /**
   * Format: yyyyMMdd
   *
   * @generated from field: string activity_date = 11;
   */
  activityDate: string;

  /**
   * @generated from field: wisetime.user.timeline.v4.PostStatus post_status = 12;
   */
  postStatus: PostStatus;

  /**
   * Set if the time row has been posted.
   *
   * @generated from field: string posted_to_site_id = 13;
   */
  postedToSiteId: string;

  /**
   * Optional error message. For example, the reason for time posting failure.
   *
   * @generated from field: string error_message = 14;
   */
  errorMessage: string;

  /**
   * @generated from field: google.protobuf.Duration total_duration = 9;
   */
  totalDuration?: Duration;

  /**
   * @generated from field: wisetime.user.timeline.v4.TimeGroup.TimeGroupSource source = 16;
   */
  source: TimeGroup_TimeGroupSource;
};

/**
 * Describes the message wisetime.user.timeline.v4.TimeGroup.
 * Use `create(TimeGroupSchema)` to create a new message.
 */
export const TimeGroupSchema: GenMessage<TimeGroup> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 47);

/**
 * Determines behaviour of `Include details from following time entries` in the action pane.
 *
 * @generated from enum wisetime.user.timeline.v4.TimeGroup.NarrativeType
 */
export enum TimeGroup_NarrativeType {
  /**
   * Expected behaviour if boundary condition reached is to log warning and assume value as NARRATIVE_AND_TIME_ROW_DESCRIPTIONS
   * The `Include details from following time entries` checkbox in the action pane is *checked*.
   *
   * @generated from enum value: NARRATIVE_TYPE_UNSPECIFIED = 0;
   */
  NARRATIVE_TYPE_UNSPECIFIED = 0,

  /**
   * The `Include detailed information of time rows` checkbox in the action pane is set to default of *unchecked*.
   *
   * @generated from enum value: NARRATIVE_ONLY = 1;
   */
  NARRATIVE_ONLY = 1,

  /**
   * The `Include detailed information of time rows` checkbox in the action pane is set to default of *checked*.
   *
   * @generated from enum value: NARRATIVE_AND_TIME_ROW_DESCRIPTIONS = 2;
   */
  NARRATIVE_AND_TIME_ROW_DESCRIPTIONS = 2,
}

/**
 * Describes the enum wisetime.user.timeline.v4.TimeGroup.NarrativeType.
 */
export const TimeGroup_NarrativeTypeSchema: GenEnum<TimeGroup_NarrativeType> = /*@__PURE__*/
  enumDesc(file_wisetime_user_timeline_v4_timeline, 47, 0);

/**
 * @generated from enum wisetime.user.timeline.v4.TimeGroup.TimeGroupSource
 */
export enum TimeGroup_TimeGroupSource {
  /**
   * @generated from enum value: TIME_GROUP_SOURCE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: TIME_GROUP_SOURCE_USER_CREATED = 1;
   */
  USER_CREATED = 1,

  /**
   * @generated from enum value: TIME_GROUP_SOURCE_BLOCK_POST = 2;
   */
  BLOCK_POST = 2,
}

/**
 * Describes the enum wisetime.user.timeline.v4.TimeGroup.TimeGroupSource.
 */
export const TimeGroup_TimeGroupSourceSchema: GenEnum<TimeGroup_TimeGroupSource> = /*@__PURE__*/
  enumDesc(file_wisetime_user_timeline_v4_timeline, 47, 1);

/**
 * @generated from message wisetime.user.timeline.v4.AddToTimeGroupRequest
 */
export type AddToTimeGroupRequest = Message<"wisetime.user.timeline.v4.AddToTimeGroupRequest"> & {
  /**
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];

  /**
   * @generated from field: string time_group_id = 2;
   */
  timeGroupId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.AddToTimeGroupRequest.
 * Use `create(AddToTimeGroupRequestSchema)` to create a new message.
 */
export const AddToTimeGroupRequestSchema: GenMessage<AddToTimeGroupRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 48);

/**
 * @generated from message wisetime.user.timeline.v4.RemoveFromTimeGroupRequest
 */
export type RemoveFromTimeGroupRequest = Message<"wisetime.user.timeline.v4.RemoveFromTimeGroupRequest"> & {
  /**
   * @generated from field: repeated string time_row_ids = 1;
   */
  timeRowIds: string[];

  /**
   * @generated from field: string time_group_id = 2;
   */
  timeGroupId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.
 * Use `create(RemoveFromTimeGroupRequestSchema)` to create a new message.
 */
export const RemoveFromTimeGroupRequestSchema: GenMessage<RemoveFromTimeGroupRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 49);

/**
 * @generated from message wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest
 */
export type UpdateTimeGroupDurationRequest = Message<"wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest"> & {
  /**
   * @generated from field: string time_group_id = 1;
   */
  timeGroupId: string;

  /**
   * this is the rounded value entered by the user
   *
   * @generated from field: google.protobuf.Duration total_duration = 6;
   */
  totalDuration?: Duration;
};

/**
 * Describes the message wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.
 * Use `create(UpdateTimeGroupDurationRequestSchema)` to create a new message.
 */
export const UpdateTimeGroupDurationRequestSchema: GenMessage<UpdateTimeGroupDurationRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 50);

/**
 * @generated from message wisetime.user.timeline.v4.UpdateTimeGroupRequest
 */
export type UpdateTimeGroupRequest = Message<"wisetime.user.timeline.v4.UpdateTimeGroupRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: wisetime.user.timeline.v4.TimeGroupUpdate time_group = 2;
   */
  timeGroup?: TimeGroupUpdate;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message wisetime.user.timeline.v4.UpdateTimeGroupRequest.
 * Use `create(UpdateTimeGroupRequestSchema)` to create a new message.
 */
export const UpdateTimeGroupRequestSchema: GenMessage<UpdateTimeGroupRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 51);

/**
 * TimeGroupUpdate fields must be a subset of TimeGroup fields.
 *
 * @generated from message wisetime.user.timeline.v4.TimeGroupUpdate
 */
export type TimeGroupUpdate = Message<"wisetime.user.timeline.v4.TimeGroupUpdate"> & {
  /**
   * @generated from field: string narrative = 2;
   */
  narrative: string;

  /**
   * @generated from field: wisetime.user.timeline.v4.TimeGroup.NarrativeType narrative_type = 3;
   */
  narrativeType: TimeGroup_NarrativeType;

  /**
   * @generated from field: wisetime.user.timeline.v4.NarrativeSource narrative_source = 4;
   */
  narrativeSource: NarrativeSource;
};

/**
 * Describes the message wisetime.user.timeline.v4.TimeGroupUpdate.
 * Use `create(TimeGroupUpdateSchema)` to create a new message.
 */
export const TimeGroupUpdateSchema: GenMessage<TimeGroupUpdate> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 52);

/**
 * @generated from message wisetime.user.timeline.v4.DeleteTimeGroupRequest
 */
export type DeleteTimeGroupRequest = Message<"wisetime.user.timeline.v4.DeleteTimeGroupRequest"> & {
  /**
   * @generated from field: repeated string time_group_ids = 2;
   */
  timeGroupIds: string[];

  /**
   * @generated from field: string time_group_id = 1 [deprecated = true];
   * @deprecated
   */
  timeGroupId: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.DeleteTimeGroupRequest.
 * Use `create(DeleteTimeGroupRequestSchema)` to create a new message.
 */
export const DeleteTimeGroupRequestSchema: GenMessage<DeleteTimeGroupRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 53);

/**
 * @generated from message wisetime.user.timeline.v4.CreateTimelineMarkerRequest
 */
export type CreateTimelineMarkerRequest = Message<"wisetime.user.timeline.v4.CreateTimelineMarkerRequest"> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * User local date, to determine which day to display a marker under.
   * Format: yyyyMMdd
   *
   * @generated from field: string date = 2;
   */
  date: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: double time_zone_offset = 4;
   */
  timeZoneOffset: number;
};

/**
 * Describes the message wisetime.user.timeline.v4.CreateTimelineMarkerRequest.
 * Use `create(CreateTimelineMarkerRequestSchema)` to create a new message.
 */
export const CreateTimelineMarkerRequestSchema: GenMessage<CreateTimelineMarkerRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 54);

/**
 * @generated from message wisetime.user.timeline.v4.DeleteTimelineMarkerRequest
 */
export type DeleteTimelineMarkerRequest = Message<"wisetime.user.timeline.v4.DeleteTimelineMarkerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.
 * Use `create(DeleteTimelineMarkerRequestSchema)` to create a new message.
 */
export const DeleteTimelineMarkerRequestSchema: GenMessage<DeleteTimelineMarkerRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 55);

/**
 * @generated from message wisetime.user.timeline.v4.AddManualTimeRequest
 */
export type AddManualTimeRequest = Message<"wisetime.user.timeline.v4.AddManualTimeRequest"> & {
  /**
   * @generated from field: repeated wisetime.user.timeline.v4.ManualTimeRow manual_time_rows = 2;
   */
  manualTimeRows: ManualTimeRow[];
};

/**
 * Describes the message wisetime.user.timeline.v4.AddManualTimeRequest.
 * Use `create(AddManualTimeRequestSchema)` to create a new message.
 */
export const AddManualTimeRequestSchema: GenMessage<AddManualTimeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 56);

/**
 * @generated from message wisetime.user.timeline.v4.ManualTimeRow
 */
export type ManualTimeRow = Message<"wisetime.user.timeline.v4.ManualTimeRow"> & {
  /**
   * Format: yyyyMMddHH
   *
   * @generated from field: uint32 activity_hour = 1;
   */
  activityHour: number;

  /**
   * @generated from field: uint32 minutes = 2;
   */
  minutes: number;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string time_zone = 5;
   */
  timeZone: string;

  /**
   * Time zone offset from UTC in hours.
   *
   * @generated from field: double time_zone_offset = 6;
   */
  timeZoneOffset: number;

  /**
   * Category of "activity" that was recorded. Defaults to "OTHER".
   *
   * @generated from field: wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory category = 7;
   */
  category: ManualTimeRow_ManualTimeCategory;
};

/**
 * Describes the message wisetime.user.timeline.v4.ManualTimeRow.
 * Use `create(ManualTimeRowSchema)` to create a new message.
 */
export const ManualTimeRowSchema: GenMessage<ManualTimeRow> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 57);

/**
 * @generated from enum wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory
 */
export enum ManualTimeRow_ManualTimeCategory {
  /**
   * @generated from enum value: MANUAL_TIME_CATEGORY_UNSPECIFIED = 0;
   */
  MANUAL_TIME_CATEGORY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: OTHER = 1;
   */
  OTHER = 1,

  /**
   * @generated from enum value: READING = 2 [deprecated = true];
   * @deprecated
   */
  READING = 2,

  /**
   * @generated from enum value: TRAVEL = 3;
   */
  TRAVEL = 3,

  /**
   * @generated from enum value: VIDEO_CALL = 4;
   */
  VIDEO_CALL = 4,

  /**
   * @generated from enum value: PHONE_CALL = 5;
   */
  PHONE_CALL = 5,

  /**
   * @generated from enum value: MEETING = 6;
   */
  MEETING = 6,

  /**
   * @generated from enum value: THINKING = 7 [deprecated = true];
   * @deprecated
   */
  THINKING = 7,

  /**
   * @generated from enum value: PAPER_WORK = 8 [deprecated = true];
   * @deprecated
   */
  PAPER_WORK = 8,

  /**
   * @generated from enum value: ON_LEAVE = 9;
   */
  ON_LEAVE = 9,

  /**
   * @generated from enum value: RESEARCHING = 10;
   */
  RESEARCHING = 10,

  /**
   * @generated from enum value: DRAFTING = 11;
   */
  DRAFTING = 11,

  /**
   * @generated from enum value: CORRESPONDING = 12;
   */
  CORRESPONDING = 12,
}

/**
 * Describes the enum wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory.
 */
export const ManualTimeRow_ManualTimeCategorySchema: GenEnum<ManualTimeRow_ManualTimeCategory> = /*@__PURE__*/
  enumDesc(file_wisetime_user_timeline_v4_timeline, 57, 0);

/**
 * @generated from message wisetime.user.timeline.v4.AddManualTimeResponse
 */
export type AddManualTimeResponse = Message<"wisetime.user.timeline.v4.AddManualTimeResponse"> & {
  /**
   * @generated from field: repeated string new_time_row_ids = 1;
   */
  newTimeRowIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.AddManualTimeResponse.
 * Use `create(AddManualTimeResponseSchema)` to create a new message.
 */
export const AddManualTimeResponseSchema: GenMessage<AddManualTimeResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 58);

/**
 * @generated from message wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest
 */
export type ClearTimeGroupErrorsRequest = Message<"wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest"> & {
  /**
   * @generated from field: repeated string time_group_ids = 1;
   */
  timeGroupIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.
 * Use `create(ClearTimeGroupErrorsRequestSchema)` to create a new message.
 */
export const ClearTimeGroupErrorsRequestSchema: GenMessage<ClearTimeGroupErrorsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 59);

/**
 * @generated from message wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse
 */
export type ClearTimeGroupErrorsResponse = Message<"wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse"> & {
  /**
   * @generated from field: repeated string affected_time_group_ids = 1;
   */
  affectedTimeGroupIds: string[];

  /**
   * @generated from field: repeated string affected_time_row_ids = 2;
   */
  affectedTimeRowIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.
 * Use `create(ClearTimeGroupErrorsResponseSchema)` to create a new message.
 */
export const ClearTimeGroupErrorsResponseSchema: GenMessage<ClearTimeGroupErrorsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 60);

/**
 * @generated from message wisetime.user.timeline.v4.TimeRow
 */
export type TimeRow = Message<"wisetime.user.timeline.v4.TimeRow"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Set if the time row belongs to a group.
   *
   * @generated from field: string time_group_id = 2;
   */
  timeGroupId: string;

  /**
   * The activity that was recorded. Could be the name of an app, a manual time category, and so on.
   *
   * @generated from field: string activity = 3;
   */
  activity: string;

  /**
   * The activity description. Could be a window title, or the description entered as manual time.
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string icon_url = 5;
   */
  iconUrl: string;

  /**
   * Duration of activity.
   *
   * @generated from field: google.protobuf.Duration duration = 7;
   */
  duration?: Duration;

  /**
   * Format: yyyyMMdd
   * User local date, to determine which day to display an ungrouped row under.
   *
   * @generated from field: string activity_date = 22;
   */
  activityDate: string;

  /**
   * The date and hour in which the activity was recorded, in UTC. Format: yyyyMMddHH
   *
   * @generated from field: uint32 activity_hour = 8;
   */
  activityHour: number;

  /**
   * first_observed_in_hour represents the minute in the activity_hour when the activity was
   * first observed. It is an integer value between 0 and 59.
   *
   * @generated from field: int32 first_observed_in_hour = 9;
   */
  firstObservedInHour: number;

  /**
   * Time zone name received from WiseTime client app.
   *
   * @generated from field: string time_zone = 10;
   */
  timeZone: string;

  /**
   * Time zone offset from UTC in hours.
   *
   * @generated from field: double time_zone_offset = 11;
   */
  timeZoneOffset: number;

  /**
   * @generated from field: repeated wisetime.user.type.TagRef tags = 12;
   */
  tags: TagRef[];

  /**
   * @generated from field: repeated wisetime.user.type.TagCategoryRef tag_categories = 21;
   */
  tagCategories: TagCategoryRef[];

  /**
   * @generated from field: repeated wisetime.user.timeline.v4.TagSuggestion tag_suggestions = 13;
   */
  tagSuggestions: TagSuggestion[];

  /**
   * @generated from field: repeated wisetime.user.type.SelectedTimesheetFieldOption selected_timesheet_field_options = 23;
   */
  selectedTimesheetFieldOptions: SelectedTimesheetFieldOption[];

  /**
   * @generated from field: wisetime.user.timeline.v4.TrashStatus trash_status = 18;
   */
  trashStatus: TrashStatus;
};

/**
 * Describes the message wisetime.user.timeline.v4.TimeRow.
 * Use `create(TimeRowSchema)` to create a new message.
 */
export const TimeRowSchema: GenMessage<TimeRow> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 61);

/**
 * @generated from message wisetime.user.timeline.v4.TagSuggestion
 */
export type TagSuggestion = Message<"wisetime.user.timeline.v4.TagSuggestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: wisetime.user.type.TagRef tag = 2;
   */
  tag?: TagRef;
};

/**
 * Describes the message wisetime.user.timeline.v4.TagSuggestion.
 * Use `create(TagSuggestionSchema)` to create a new message.
 */
export const TagSuggestionSchema: GenMessage<TagSuggestion> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 62);

/**
 * @generated from message wisetime.user.timeline.v4.TimelineMarker
 */
export type TimelineMarker = Message<"wisetime.user.timeline.v4.TimelineMarker"> & {
  /**
   * An identifier that is unique for any given user, for this time marker record.
   * For e.g. this could be the calendar event ID, or for desktop app, a self-generated UUID.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * User local date, to determine which day to display a marker under.
   * Format: yyyyMMdd
   *
   * @generated from field: string date = 3;
   */
  date: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 4;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 5;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: double time_zone_offset = 6;
   */
  timeZoneOffset: number;

  /**
   * @generated from field: repeated wisetime.user.type.TagRef tags = 7;
   */
  tags: TagRef[];
};

/**
 * Describes the message wisetime.user.timeline.v4.TimelineMarker.
 * Use `create(TimelineMarkerSchema)` to create a new message.
 */
export const TimelineMarkerSchema: GenMessage<TimelineMarker> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 63);

/**
 * @generated from message wisetime.user.timeline.v4.CountFilteredTimeRowsRequest
 */
export type CountFilteredTimeRowsRequest = Message<"wisetime.user.timeline.v4.CountFilteredTimeRowsRequest"> & {
  /**
   * Start of range, inclusive. Format: yyyyMMdd
   *
   * @generated from field: string start_date = 1;
   */
  startDate: string;

  /**
   * End of range, inclusive. Format: yyyyMMdd
   *
   * @generated from field: string end_date = 2;
   */
  endDate: string;

  /**
   * @generated from field: wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter filter = 4;
   */
  filter?: CountFilteredTimeRowsRequest_Filter;
};

/**
 * Describes the message wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.
 * Use `create(CountFilteredTimeRowsRequestSchema)` to create a new message.
 */
export const CountFilteredTimeRowsRequestSchema: GenMessage<CountFilteredTimeRowsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 64);

/**
 * @generated from message wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter
 */
export type CountFilteredTimeRowsRequest_Filter = Message<"wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter"> & {
  /**
   * Could be the name of an app, a manual time category, and so on.
   *
   * @generated from field: repeated string activities = 1;
   */
  activities: string[];

  /**
   * Could be a window title, or the description entered as manual time.
   *
   * @generated from field: repeated string descriptions = 2;
   */
  descriptions: string[];

  /**
   * @generated from field: repeated string tag_ids = 3;
   */
  tagIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.
 * Use `create(CountFilteredTimeRowsRequest_FilterSchema)` to create a new message.
 */
export const CountFilteredTimeRowsRequest_FilterSchema: GenMessage<CountFilteredTimeRowsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 64, 0);

/**
 * @generated from message wisetime.user.timeline.v4.CountFilteredTimeRowsResponse
 */
export type CountFilteredTimeRowsResponse = Message<"wisetime.user.timeline.v4.CountFilteredTimeRowsResponse"> & {
  /**
   * <yyyyMMdd, count>
   *
   * @generated from field: map<string, uint32> day_counts = 1;
   */
  dayCounts: { [key: string]: number };
};

/**
 * Describes the message wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.
 * Use `create(CountFilteredTimeRowsResponseSchema)` to create a new message.
 */
export const CountFilteredTimeRowsResponseSchema: GenMessage<CountFilteredTimeRowsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 65);

/**
 * @generated from message wisetime.user.timeline.v4.MergeTimeGroupsRequest
 */
export type MergeTimeGroupsRequest = Message<"wisetime.user.timeline.v4.MergeTimeGroupsRequest"> & {
  /**
   * @generated from field: repeated string time_group_ids = 1;
   */
  timeGroupIds: string[];
};

/**
 * Describes the message wisetime.user.timeline.v4.MergeTimeGroupsRequest.
 * Use `create(MergeTimeGroupsRequestSchema)` to create a new message.
 */
export const MergeTimeGroupsRequestSchema: GenMessage<MergeTimeGroupsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_timeline_v4_timeline, 66);

/**
 * @generated from enum wisetime.user.timeline.v4.NarrativeSource
 */
export enum NarrativeSource {
  /**
   * @generated from enum value: NARRATIVE_SOURCE_UNSPECIFIED = 0;
   */
  NARRATIVE_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: AI_GENERATED = 2;
   */
  AI_GENERATED = 2,
}

/**
 * Describes the enum wisetime.user.timeline.v4.NarrativeSource.
 */
export const NarrativeSourceSchema: GenEnum<NarrativeSource> = /*@__PURE__*/
  enumDesc(file_wisetime_user_timeline_v4_timeline, 0);

/**
 * @generated from enum wisetime.user.timeline.v4.PostStatus
 */
export enum PostStatus {
  /**
   * Private, un-posted time.
   *
   * @generated from enum value: NOT_POSTED = 0;
   */
  NOT_POSTED = 0,

  /**
   * Queued, currently being posted.
   *
   * @generated from enum value: PENDING = 1;
   */
  PENDING = 1,

  /**
   * Failed to post to external system, will retry.
   *
   * @generated from enum value: TRANSIENT_FAILURE = 2;
   */
  TRANSIENT_FAILURE = 2,

  /**
   * Permanent failure posting time. Time posting will not be automatically retried.
   *
   * @generated from enum value: FAILED = 3;
   */
  FAILED = 3,

  /**
   * Time has been posted.
   *
   * @generated from enum value: SUCCESS = 5;
   */
  SUCCESS = 5,
}

/**
 * Describes the enum wisetime.user.timeline.v4.PostStatus.
 */
export const PostStatusSchema: GenEnum<PostStatus> = /*@__PURE__*/
  enumDesc(file_wisetime_user_timeline_v4_timeline, 1);

/**
 * @generated from enum wisetime.user.timeline.v4.TrashStatus
 */
export enum TrashStatus {
  /**
   * @generated from enum value: NOT_TRASHED = 0;
   */
  NOT_TRASHED = 0,

  /**
   * Trashed, but not permanently deleted.
   *
   * @generated from enum value: TRASHED = 1;
   */
  TRASHED = 1,
}

/**
 * Describes the enum wisetime.user.timeline.v4.TrashStatus.
 */
export const TrashStatusSchema: GenEnum<TrashStatus> = /*@__PURE__*/
  enumDesc(file_wisetime_user_timeline_v4_timeline, 2);

/**
 * Resources of the Timeline service API include:
 *
 * - user/timelines/*
 * - user/timelines/status
 * - user/day-summaries/*
 * - user/time-rows/*
 * - user/time-groups/*
 * - user/manual-time/*
 * - user/manual-time-comments/*
 *
 * Unless otherwise specified, time information provided by this service is in UTC.
 *
 *
 * @generated from service wisetime.user.timeline.v4.TimelineService
 */
export const TimelineService: GenService<{
  /**
   * Call this RPC to load time rows and time groups for day tabs in the timeline.
   *
   * This RPC is currently used in timeline "experimental" but not in timeline "stable".
   *
   * Returns time rows whose activity hour falls on one of the dates within the requested range when the
   * hour is resolved in the time zone in which the row was recorded.
   *
   * For example, if a time row was recorded with activity_hour 2023052120 (21 May at 20:00 UTC), and with
   * time zone offset +8, then the time of the activity in the +8 time zone is 2023052204 (22 May at 04:00).
   * The date of the activity is considered to be 22 May 2023.
   *
   * This RPC will include implicitly created time groups in the response. Implicitly created time groups
   * are time groups that are created when the user posts ungrouped time rows.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Start and end dates are required
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.ListTimelines
   */
  listTimelines: {
    methodKind: "unary";
    input: typeof ListTimelinesRequestSchema;
    output: typeof ListTimelinesResponseSchema;
  },
  /**
   * Determine timeline status from last known time upload.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.GetTimelineStatus
   */
  getTimelineStatus: {
    methodKind: "unary";
    input: typeof GetTimelineStatusRequestSchema;
    output: typeof TimelineStatusSchema;
  },
  /**
   * Day summaries are used to provide calendar tab indicators in the timeline UI.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.ListDaySummaries
   */
  listDaySummaries: {
    methodKind: "unary";
    input: typeof ListDaySummariesRequestSchema;
    output: typeof ListDaySummariesResponseSchema;
  },
  /**
   * List time rows for current user, within the specified start and end date.
   * If a time row is part of a time group, then the group's date is used instead to perform the match.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.ListTimeRowsByDate
   */
  listTimeRowsByDate: {
    methodKind: "unary";
    input: typeof ListTimeRowsByDateRequestSchema;
    output: typeof ListTimeRowsByDateResponseSchema;
  },
  /**
   * Subscribe to be notified of timeline update events.
   * Notifications will be sent whenever there are time row and time group updates for the current user.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.WatchTimelineUpdates
   */
  watchTimelineUpdates: {
    methodKind: "server_streaming";
    input: typeof WatchTimelineUpdatesRequestSchema;
    output: typeof TimelineUpdateSchema;
  },
  /**
   * Post time to a site.
   *
   * Posting of ungrouped time rows will implicitly create time groups for distinct row tags and activity type
   * combinations. PostTimeResponse will include these implicitly created time groups together with the explicitly
   * posted time groups.
   *
   * Instead of simply supplying time row IDs and time group IDs, the caller is required to provide PostTimeRow and
   * PostTimeGroup entities. This is so that the service can ensure that the caller's state is not out of sync as it
   * tries to post time. This is important because the service will implicitly apply a tag suggestion if a time row
   * is posted without any tags. Therefore, the caller is required to be explicit about what it wishes to post.
   * In case of any failure, no time group nor row will be posted.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   *                        Each time group's rounded total duration should be at least 30 seconds.
   * - NOT_FOUND:           If provided time group (or at least one time row) doesn't exist in the DB
   *                        If site does not exist
   * - PERMISSION_DENIED:   If time group (or at least one time row) belongs to another user or user is not a member of
   *                        the requested team
   * - FAILED_PRECONDITION: If any time group/row has out of sync tag or activity type
   *                        If any time group/row has an attached tag category. Tag categories cannot be posted.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.PostTime
   */
  postTime: {
    methodKind: "unary";
    input: typeof PostTimeRequestSchema;
    output: typeof PostTimeResponseSchema;
  },
  /**
   * Attempt to cancel a previous PostTime request.
   * If the posted time is still pending, it will be cancelled immediately.
   * If the posted time is still being processed, it will be cancelled, possibly after a delay.
   * If the posted time is processed or completed, it will not be cancelled.
   * This RPC returns without waiting for the outcome of attempted cancellations.
   * You can use WatchTimelineUpdates to be notified of updates.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.CancelPostTime
   */
  cancelPostTime: {
    methodKind: "unary";
    input: typeof CancelPostTimeRequestSchema;
    output: typeof CancelPostTimeResponseSchema;
  },
  /**
   * Attach a tag to time rows or to a time group.
   * If the tag to be attached was a suggested tag for a time row, this has the effect of accepting the suggestion.
   * If the tag belongs to a tag category that is currently attached, the tag category will be detached in favour of
   * the tag, which has more specificity than the category.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           If the tag, time group or at least one time row doesn't exist in the DB
   * - PERMISSION_DENIED:   If time group (or at least one time row) belongs to another user or user is not a member of
   *                        the requested team
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.AttachTag
   */
  attachTag: {
    methodKind: "unary";
    input: typeof AttachTagRequestSchema;
    output: typeof AttachTagResponseSchema;
  },
  /**
   * Detach a tag from time rows or from a time group.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED:   If time group (or at least one time row) belongs to another user or user is not a member of
   *                        the requested team
   * - FAILED_PRECONDITION: If the tag is not attached to time row or group
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.DetachTag
   */
  detachTag: {
    methodKind: "unary";
    input: typeof DetachTagRequestSchema;
    output: typeof DetachTagResponseSchema;
  },
  /**
   * Detach a tag category from time rows or from a time group.
   * Note that we don't need an AttachTagCategory RPC. Tag categories are only applied
   * at ingress time, cannot be manually applied by the user.
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED:   If time group (or at least one time row) belongs to another user or user is not a member of
   *                        the requested team
   * - FAILED_PRECONDITION: If the tag category is not attached to the time row or group
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.DetachTagCategory
   */
  detachTagCategory: {
    methodKind: "unary";
    input: typeof DetachTagCategoryRequestSchema;
    output: typeof DetachTagCategoryResponseSchema;
  },
  /**
   * Apply suggested tag to a time row.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - FAILED_PRECONDITION: If the suggested tag doesn't exist
   * - PERMISSION_DENIED:   If the user does not own the time row
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.AcceptTagSuggestion
   */
  acceptTagSuggestion: {
    methodKind: "unary";
    input: typeof AcceptTagSuggestionRequestSchema;
    output: typeof AcceptTagSuggestionResponseSchema;
  },
  /**
   * Decline suggested tag from a time row.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - FAILED_PRECONDITION: If the suggestion doesn't exist
   * - PERMISSION_DENIED:   If the user does not own the time row
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.DeclineTagSuggestion
   */
  declineTagSuggestion: {
    methodKind: "unary";
    input: typeof DeclineTagSuggestionRequestSchema;
    output: typeof DeclineTagSuggestionResponseSchema;
  },
  /**
   * For a given time group (timesheet entry), select/apply a timesheet field option.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           Time group, timesheet field or timesheet field option not found
   * - FAILED_PRECONDITION: Selected timesheet field option is not applicable. For example, option is for another
   *                        field, or cannot be used with the tag currently attached to the time group.
   *
   * If the timesheet field option selection is successful, the frontend should call the GenerateTimesheetFieldConfigs
   * RPC of TimesheetFieldService so that it can refresh the state of the timesheet fields for the time group.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.SelectTimesheetFieldOption
   */
  selectTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof SelectTimesheetFieldOptionRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * For a given time group (timesheet entry), clear the specified timesheet field.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           Time group, or timesheet field not found
   *
   * If the clear timesheet field call is successful, the frontend should call the GenerateTimesheetFieldConfigs
   * RPC of TimesheetFieldService so that it can refresh the state of the timesheet fields for the time group.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.ClearTimesheetField
   */
  clearTimesheetField: {
    methodKind: "unary";
    input: typeof ClearTimesheetFieldRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * For a given time rows (timesheet entry), select/apply a timesheet field option.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           Time rows, timesheet field or timesheet field option not found
   * - FAILED_PRECONDITION: Selected timesheet field option is not applicable. For example, option is for another
   *                        field, or cannot be used with the tag currently attached to the time rows.
   *
   * If the timesheet field option selection is successful, the frontend should call the GenerateTimesheetFieldConfigs
   * RPC of TimesheetFieldService so that it can refresh the state of the timesheet fields for the time rows.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.SelectRowTimesheetFieldOption
   */
  selectRowTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof SelectRowTimesheetFieldOptionRequestSchema;
    output: typeof SelectRowTimesheetFieldOptionResponseSchema;
  },
  /**
   * For a given time rows (timesheet entry), clear the specified timesheet field.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           Time rows, or timesheet field not found
   *
   * If the clear timesheet field call is successful, the frontend should call the GenerateTimesheetFieldConfigs
   * RPC of TimesheetFieldService so that it can refresh the state of the timesheet fields for the time rows.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.ClearRowTimesheetField
   */
  clearRowTimesheetField: {
    methodKind: "unary";
    input: typeof ClearRowTimesheetFieldRequestSchema;
    output: typeof ClearRowTimesheetFieldResponseSchema;
  },
  /**
   * Trashed time rows are not permanently deleted and can be untrashed.
   * Trashed time rows, like any other time rows, are automatically deleted after a period of time
   * that is determined by the user's data retention setting.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - FAILED_PRECONDITION: If rows do not exist
   *                        If rows have already been posted to a site
   * - PERMISSION_DENIED:   If the user does not own the time row/s
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.TrashTimeRows
   */
  trashTimeRows: {
    methodKind: "unary";
    input: typeof TrashTimeRowsRequestSchema;
    output: typeof TrashTimeRowsResponseSchema;
  },
  /**
   * Restore a trashed time row.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - FAILED_PRECONDITION: If rows do not exist
   *                        If rows have already been posted to a site
   * - PERMISSION_DENIED:   If the user does not own the time row/s
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.UnTrashTimeRows
   */
  unTrashTimeRows: {
    methodKind: "unary";
    input: typeof UnTrashTimeRowsRequestSchema;
    output: typeof UnTrashTimeRowsResponseSchema;
  },
  /**
   * Permanently delete unposted time rows, whether they are currently trashed or not.
   *
   * Possible failures:
   * - INVALID_ARGUMENT: Request is invalid (one or more required fields are missing or in an invalid format)
   *                     If number of rows in the database do not match number of rows in request
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.ImmediatelyDeleteTimeRows
   */
  immediatelyDeleteTimeRows: {
    methodKind: "unary";
    input: typeof ImmediatelyDeleteTimeRowsRequestSchema;
    output: typeof ImmediatelyDeleteTimeRowsResponseSchema;
  },
  /**
   * Permanently delete all trashed time rows.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.EmptyTrash
   */
  emptyTrash: {
    methodKind: "unary";
    input: typeof EmptyTrashRequestSchema;
    output: typeof EmptyTrashResponseSchema;
  },
  /**
   * Group one or more time row/s.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - FAILED_PRECONDITION: If one or more time rows don't exist
   * - PERMISSION_DENIED:   If the user does not own the time row/s
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.CreateTimeGroup
   */
  createTimeGroup: {
    methodKind: "unary";
    input: typeof CreateTimeGroupRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * Create an empty time group, without any time rows.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    All fields are required.
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.CreateEmptyTimeGroup
   */
  createEmptyTimeGroup: {
    methodKind: "unary";
    input: typeof CreateEmptyTimeGroupRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * Add time row(s) to a time group.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           If time group or time row(s) do not exist in the db
   * - PERMISSION_DENIED:   If time group or time row(s) does not belong to the current user
   * - FAILED_PRECONDITION: If time group or time row(s) are already posted or if time row(s) already attached to the
   *                        time group
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.AddToTimeGroup
   */
  addToTimeGroup: {
    methodKind: "unary";
    input: typeof AddToTimeGroupRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * Remove time rows from a time group.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           If time group or at least one of time rows doesn't exist in the DB
   * - PERMISSION_DENIED:   If time group or time row(s) does not belong to the current user
   * - FAILED_PRECONDITION: If time group or at least one of time rows is already posted or time log is not a part of the
   *                        time group
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.RemoveFromTimeGroup
   */
  removeFromTimeGroup: {
    methodKind: "unary";
    input: typeof RemoveFromTimeGroupRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * Update a time group, updatable fields are defined in TimeGroupUpdate (a subset of TimeGroup fields):
   * - name
   * - narrative
   * - narrative_type
   *
   * This method doesn't allow to add/remove time rows and doesn't allow to change tags, activity types,
   * and total duration
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           If the time group doesn't exist
   * - PERMISSION_DENIED:   If the time group belongs to another user or user is not a member of the requested team
   * - FAILED_PRECONDITION: If the time group has already been posted
   *
   * Target resource name: time-groups/*
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.UpdateTimeGroup
   */
  updateTimeGroup: {
    methodKind: "unary";
    input: typeof UpdateTimeGroupRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * Target resource name: time-groups/*
   * This method should only be called when user *explicitly* changes duration.
   * It should *not* be called for example, when row is attached/detached to a group.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           If the time group doesn't exist
   * - PERMISSION_DENIED:   If the time group belongs to another user or user is not a member of the requested site
   * - FAILED_PRECONDITION: If the time group has an immutable post status
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.UpdateTimeGroupDuration
   */
  updateTimeGroupDuration: {
    methodKind: "unary";
    input: typeof UpdateTimeGroupDurationRequestSchema;
    output: typeof TimeGroupSchema;
  },
  /**
   * Permanently delete a time group.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           If the time group doesn't exist
   * - FAILED_PRECONDITION: If time group does not exist
   *                        If the user does not own the time group
   *                        If the time group has a non-deletable post status
   *                        Unknown database state
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.DeleteTimeGroup
   */
  deleteTimeGroup: {
    methodKind: "unary";
    input: typeof DeleteTimeGroupRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Create a new timeline marker.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    All fields are required
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.CreateTimelineMarker
   */
  createTimelineMarker: {
    methodKind: "unary";
    input: typeof CreateTimelineMarkerRequestSchema;
    output: typeof TimelineMarkerSchema;
  },
  /**
   * Permanently delete a timeline marker.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    ID is required
   * - NOT_FOUND:           If the timeline marker could not be found
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.DeleteTimelineMarker
   */
  deleteTimelineMarker: {
    methodKind: "unary";
    input: typeof DeleteTimelineMarkerRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Add manual time
   *
   * Possible failures:
   * - INVALID_ARGUMENT: Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:        If manual time activity type not found
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.AddManualTime
   */
  addManualTime: {
    methodKind: "unary";
    input: typeof AddManualTimeRequestSchema;
    output: typeof AddManualTimeResponseSchema;
  },
  /**
   * Count filtered time rows by day using provided filter.
   *
   * Possible failures:
   * - INVALID_ARGUMENT: Request is invalid (one or more required fields are missing or in an invalid format)
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.CountFilteredTimeRows
   */
  countFilteredTimeRows: {
    methodKind: "unary";
    input: typeof CountFilteredTimeRowsRequestSchema;
    output: typeof CountFilteredTimeRowsResponseSchema;
  },
  /**
   * Clear errors for time groups with status: Failed
   * Possible failures:
   * - INVALID_ARGUMENT: At least one time group ID must be provided
   * - FAILED_PRECONDITION: If time some groups have already been posted to a site
   * - NOT_FOUND: If some time groups do not exist
   * - PERMISSION_DENIED:   If the user does not own the time group/s
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.ClearTimeGroupErrors
   */
  clearTimeGroupErrors: {
    methodKind: "unary";
    input: typeof ClearTimeGroupErrorsRequestSchema;
    output: typeof ClearTimeGroupErrorsResponseSchema;
  },
  /**
   * Time groups from the request will be removed and a new time group will be created. At least 2 time groups are required.
   * If there are conflicting activity types - resulting time group will have no activity type.
   * Sum of durations will be calculated (either entered by user or rows raw duration).
   * For tags, tag categories - union will be used.
   * Narratives will be concatenated with a newline.
   * Narrative type - NARRATIVE_ONLY is preferred over NARRATIVE_AND_TIME_ROW_DESCRIPTIONS.
   * Possible failures include (but not limited to):
   * - FAILED_PRECONDITION: activity_date doesn't match in time groups
   *
   * @generated from rpc wisetime.user.timeline.v4.TimelineService.MergeTimeGroups
   */
  mergeTimeGroups: {
    methodKind: "unary";
    input: typeof MergeTimeGroupsRequestSchema;
    output: typeof TimeGroupSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_user_timeline_v4_timeline, 0);

